import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.help');
import * as showdown from 'showdown';
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

interface HelpCategory {
    id: string;
    title: string;
    description: string;
    icon: string;
}

interface HelpSection {
    title: string;
    paragraphs?: string[];
    steps?: string[];
    bullets?: string[];
    code?: string;
    note?: string;
    warning?: string;
}

interface HelpGuide {
    id: string;
    category: string;
    title: string;
    summary: string;
    icon: string;
    audience: string;
    path?: string;
    tags: string[];
    sections: HelpSection[];
}

interface HelpVisual {
    asset: string;
    alt: string;
    caption: string;
}

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-help',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.help/view.scss */
:host {
  display: block;
  height: 100%;
}

.help-page {
  --help-ink: #18181b;
  --help-muted: #64748b;
  --help-border: #e2e8f0;
  --help-soft: #f8fafc;
  --help-brand: #4f46e5;
  --help-brand-soft: #eef2ff;
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  color: var(--help-ink);
  background: radial-gradient(circle at 8% -10%, rgba(99, 102, 241, 0.1), transparent 30%), #f8fafc;
}

.help-hero {
  position: relative;
  z-index: 2;
  display: flex;
  flex: 0 0 auto;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;
  padding: 24px 32px 22px;
  border-bottom: 1px solid var(--help-border);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(14px);
}

.help-hero-copy {
  min-width: 0;
}
.help-hero-copy h1 {
  margin: 6px 0 4px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.025em;
  color: #09090b;
}
.help-hero-copy > p {
  max-width: 760px;
  margin: 0;
  font-size: 13px;
  line-height: 1.65;
  color: #64748b;
}

.help-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.14em;
  color: var(--help-brand);
}
.help-eyebrow i {
  font-size: 15px;
}

.help-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}
.help-stats span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 9px;
  border: 1px solid #e4e4e7;
  border-radius: 999px;
  font-size: 11px;
  color: #71717a;
  background: #fff;
}
.help-stats strong {
  font-weight: 700;
  color: #27272a;
}
.help-stats i {
  font-size: 13px;
  color: #16a34a;
}

.help-search-wrap {
  width: min(390px, 38vw);
  flex: 0 0 auto;
}
.help-search-wrap > label {
  display: block;
  margin-bottom: 7px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
}
.help-search-wrap > p {
  margin: 6px 2px 0;
  font-size: 10px;
  color: #94a3b8;
}

.help-search {
  display: flex;
  height: 42px;
  align-items: center;
  gap: 9px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}
.help-search:focus-within {
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.13);
}
.help-search > i {
  flex: 0 0 auto;
  font-size: 18px;
  color: #64748b;
}
.help-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  font-size: 13px;
  color: #18181b;
  background: transparent;
}
.help-search input::placeholder {
  color: #a1a1aa;
}
.help-search input::-webkit-search-cancel-button {
  display: none;
}
.help-search button {
  display: inline-flex;
  width: 26px;
  height: 26px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  color: #71717a;
  background: #f4f4f5;
  cursor: pointer;
}
.help-search button:hover {
  color: #27272a;
  background: #e4e4e7;
}

.help-tabs {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  padding: 0 32px;
  border-bottom: 1px solid var(--help-border);
  background: rgba(255, 255, 255, 0.88);
}

.help-tab-scroll {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: none;
}
.help-tab-scroll::-webkit-scrollbar {
  display: none;
}

.help-tab {
  position: relative;
  display: inline-flex;
  height: 48px;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  padding: 0 14px;
  border: 0;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  transition: color 120ms ease, background 120ms ease;
}
.help-tab::after {
  position: absolute;
  right: 10px;
  bottom: 0;
  left: 10px;
  height: 2px;
  border-radius: 999px 999px 0 0;
  background: transparent;
  content: "";
}
.help-tab i {
  font-size: 16px;
}
.help-tab span {
  font-size: 11px;
  font-weight: 750;
  white-space: nowrap;
}
.help-tab small {
  display: inline-flex;
  min-width: 21px;
  height: 19px;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  color: #64748b;
  background: #f1f5f9;
}
.help-tab:hover {
  color: #3730a3;
  background: #f8fafc;
}
.help-tab.is-active {
  color: #4338ca;
  background: #f8fafc;
}
.help-tab.is-active::after {
  background: #4f46e5;
}
.help-tab.is-active small {
  color: #4338ca;
  background: #e0e7ff;
}

.help-body {
  display: grid;
  flex: 1 1 auto;
  min-height: 0;
  grid-template-columns: 310px minmax(0, 1fr);
  gap: 0;
}

.help-sidebar {
  min-height: 0;
  overflow-y: auto;
  border-right: 1px solid var(--help-border);
  background: rgba(255, 255, 255, 0.76);
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.help-sidebar-section {
  padding: 18px 16px;
}
.help-sidebar-section + .help-sidebar-section {
  border-top: 1px solid #e2e8f0;
}

.help-sidebar-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 4px 10px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #94a3b8;
  text-transform: uppercase;
}
.help-sidebar-heading span:last-child {
  display: inline-flex;
  min-width: 22px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #64748b;
  background: #f1f5f9;
}

.help-tree {
  padding-bottom: 28px;
}

.help-tree-group {
  margin-top: 7px;
}

.help-tree-parent {
  display: grid;
  width: 100%;
  grid-template-columns: 16px 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  padding: 8px 9px;
  border: 0;
  border-radius: 9px;
  text-align: left;
  color: #475569;
  background: transparent;
  cursor: pointer;
  transition: color 120ms ease, background 120ms ease;
}
.help-tree-parent:hover, .help-tree-parent.is-open {
  color: #3730a3;
  background: #f8fafc;
}

.help-tree-chevron {
  font-size: 15px;
  color: #94a3b8;
}

.help-tree-category-icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 16px;
  color: #4f46e5;
  background: #eef2ff;
}

.help-tree-parent-copy {
  min-width: 0;
}
.help-tree-parent-copy strong,
.help-tree-parent-copy small {
  display: block;
}
.help-tree-parent-copy strong {
  font-size: 12px;
  font-weight: 750;
  line-height: 1.35;
}
.help-tree-parent-copy small {
  margin-top: 2px;
  overflow: hidden;
  font-size: 9px;
  line-height: 1.3;
  color: #94a3b8;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.help-tree-count {
  display: inline-flex;
  min-width: 24px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 750;
  color: #64748b;
  background: #f1f5f9;
}

.help-tree-children {
  position: relative;
  margin: 2px 0 8px 15px;
  padding-left: 8px;
}
.help-tree-children::before {
  position: absolute;
  top: 0;
  bottom: 11px;
  left: 8px;
  width: 1px;
  background: #dbe3ef;
  content: "";
}
.help-tree-children .help-guide-item {
  position: relative;
  grid-template-columns: 10px 30px minmax(0, 1fr) 16px;
  gap: 7px;
  padding: 8px 7px 8px 0;
}
.help-tree-children .help-guide-icon {
  width: 30px;
  height: 30px;
  font-size: 15px;
}

.help-tree-line {
  position: relative;
  z-index: 1;
  display: block;
  width: 10px;
  height: 1px;
  margin-top: 15px;
  background: #dbe3ef;
}

.help-category,
.help-guide-item {
  width: 100%;
  border: 0;
  text-align: left;
  cursor: pointer;
}

.help-category {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  margin-top: 3px;
  padding: 8px 9px;
  border-radius: 9px;
  color: #475569;
  background: transparent;
  transition: color 120ms ease, background 120ms ease;
}
.help-category:hover {
  color: #312e81;
  background: #f1f5f9;
}
.help-category.is-active {
  color: #3730a3;
  background: #eef2ff;
}
.help-category.is-active .help-category-icon {
  color: #fff;
  background: #4f46e5;
}
.help-category.is-active .help-category-count {
  color: #4338ca;
  background: #fff;
}

.help-category-icon,
.help-guide-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.help-category-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  font-size: 17px;
  color: #64748b;
  background: #f1f5f9;
}

.help-category-copy,
.help-guide-copy {
  min-width: 0;
}
.help-category-copy strong,
.help-category-copy small,
.help-guide-copy strong,
.help-guide-copy small {
  display: block;
}

.help-category-copy strong {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
}
.help-category-copy small {
  margin-top: 2px;
  overflow: hidden;
  font-size: 10px;
  line-height: 1.3;
  color: #94a3b8;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.help-category-count {
  display: inline-flex;
  min-width: 25px;
  height: 21px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  background: #f1f5f9;
}

.help-document-list {
  padding-bottom: 28px;
}

.help-guide-item {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) 16px;
  align-items: start;
  gap: 9px;
  margin-top: 4px;
  padding: 10px 9px;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #475569;
  background: transparent;
  transition: border-color 120ms ease, box-shadow 120ms ease, background 120ms ease;
}
.help-guide-item:hover {
  border-color: #e2e8f0;
  background: #fff;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
}
.help-guide-item.is-active {
  border-color: #c7d2fe;
  background: #fff;
  box-shadow: 0 5px 16px rgba(79, 70, 229, 0.1);
}
.help-guide-item.is-active .help-guide-icon {
  color: #4f46e5;
  background: #eef2ff;
}
.help-guide-item.is-active .help-guide-copy strong {
  color: #3730a3;
}
.help-guide-item.is-active .help-guide-arrow {
  color: #6366f1;
}

.help-guide-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 16px;
  color: #64748b;
  background: #f1f5f9;
}

.help-guide-copy strong {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  color: #334155;
}
.help-guide-copy small {
  display: -webkit-box;
  margin-top: 3px;
  overflow: hidden;
  font-size: 10px;
  line-height: 1.45;
  color: #94a3b8;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.help-guide-arrow {
  margin-top: 8px;
  font-size: 16px;
  color: #cbd5e1;
}

.help-empty-list,
.help-empty-article {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
.help-empty-list > i,
.help-empty-article > i {
  color: #a5b4fc;
}
.help-empty-list strong,
.help-empty-list h2,
.help-empty-article strong,
.help-empty-article h2 {
  color: #334155;
}
.help-empty-list p,
.help-empty-article p {
  color: #94a3b8;
}
.help-empty-list button,
.help-empty-article button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 0;
  border-radius: 8px;
  font-weight: 700;
  color: #4338ca;
  background: #eef2ff;
  cursor: pointer;
}

.help-empty-list {
  padding: 34px 12px;
}
.help-empty-list > i {
  font-size: 32px;
}
.help-empty-list strong {
  margin-top: 10px;
  font-size: 12px;
}
.help-empty-list p {
  margin: 5px 0 12px;
  font-size: 10px;
  line-height: 1.5;
}
.help-empty-list button {
  padding: 7px 10px;
  font-size: 11px;
}

.help-article-shell {
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.help-article {
  width: min(980px, 100% - 48px);
  margin: 0 auto;
  padding: 26px 0 48px;
}

.help-breadcrumb {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 16px;
  overflow: hidden;
  font-size: 10px;
  color: #94a3b8;
  white-space: nowrap;
}
.help-breadcrumb i {
  font-size: 13px;
}
.help-breadcrumb strong {
  overflow: hidden;
  font-weight: 600;
  color: #64748b;
  text-overflow: ellipsis;
}

.help-article-header {
  padding: 26px 28px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(238, 242, 255, 0.82), rgba(255, 255, 255, 0.96) 56%), #fff;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.05);
}

.help-article-heading {
  display: flex;
  align-items: center;
  gap: 14px;
}
.help-article-heading h2 {
  margin: 7px 0 0;
  font-size: 25px;
  font-weight: 750;
  line-height: 1.25;
  letter-spacing: -0.025em;
  color: #18181b;
}

.help-article-icon {
  display: inline-flex;
  width: 50px;
  height: 50px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #c7d2fe;
  border-radius: 13px;
  font-size: 25px;
  color: #4f46e5;
  background: #fff;
  box-shadow: 0 5px 14px rgba(79, 70, 229, 0.1);
}

.help-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.help-category-badge,
.help-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
}

.help-category-badge {
  color: #475569;
  background: #e2e8f0;
}

.help-status-badge.is-current {
  color: #047857;
  background: #d1fae5;
}
.help-status-badge.is-product {
  color: #1d4ed8;
  background: #dbeafe;
}
.help-status-badge i {
  font-size: 11px;
}

.help-article-summary {
  margin: 17px 0 0;
  font-size: 14px;
  line-height: 1.75;
  color: #475569;
}

.help-sources {
  display: grid;
  gap: 7px;
  margin-top: 14px;
}

.help-source {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  min-height: 30px;
  padding: 5px 7px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 10px;
  color: #94a3b8;
  background: #f8fafc;
}
.help-source i {
  flex: 0 0 auto;
  font-size: 14px;
}
.help-source span {
  flex: 0 0 auto;
  font-weight: 700;
}
.help-source code {
  overflow: hidden;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.help-source button {
  display: inline-flex;
  height: 28px;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding: 0 9px;
  border: 1px solid #c7d2fe;
  border-radius: 7px;
  font-size: 10px;
  font-weight: 700;
  color: #4338ca;
  background: #eef2ff;
  cursor: pointer;
}
.help-source button:hover {
  border-color: #818cf8;
  background: #e0e7ff;
}

.help-visual {
  overflow: hidden;
  margin: 16px 0 0;
  border: 1px solid #dbe4f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 22px rgba(15, 23, 42, 0.045);
}

.help-visual-toolbar {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(90deg, #f8fafc, #eef2ff);
}
.help-visual-toolbar span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 750;
  color: #334155;
}
.help-visual-toolbar i {
  font-size: 15px;
  color: #4f46e5;
}
.help-visual-toolbar small {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #64748b;
}

.help-visual-original {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #4338ca;
  background: #fff;
  text-decoration: none;
}
.help-visual-original:hover, .help-visual-original:focus-visible {
  background: #eef2ff;
  outline: 2px solid #818cf8;
  outline-offset: 2px;
}

.help-visual-hint {
  display: none;
}

.help-visual-canvas {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: #fff;
}
.help-visual-canvas img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.help-visual figcaption {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: 0;
  padding: 11px 16px 13px;
  border-top: 1px solid #e2e8f0;
  font-size: 11px;
  line-height: 1.65;
  color: #64748b;
}
.help-visual figcaption i {
  flex: 0 0 auto;
  margin-top: 2px;
  font-size: 14px;
  color: #6366f1;
}

.help-section {
  margin-top: 16px;
  padding: 24px 26px;
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.035);
}
.help-section > h3 {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0 0 16px;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.4;
  color: #27272a;
}

.help-section-number {
  display: inline-flex;
  width: 23px;
  height: 23px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  font-size: 10px;
  font-weight: 800;
  color: #4338ca;
  background: #eef2ff;
}

.help-paragraph {
  margin: 0;
  font-size: 13px;
  line-height: 1.8;
  color: #475569;
}
.help-paragraph + .help-paragraph {
  margin-top: 9px;
}

.help-bullets,
.help-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 1.7;
  color: #475569;
}
.help-bullets:not(:first-child),
.help-steps:not(:first-child) {
  margin-top: 14px;
}

.help-bullets li {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: start;
  gap: 7px;
}
.help-bullets li i {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  border-radius: 999px;
  font-size: 12px;
  color: #15803d;
  background: #dcfce7;
}

.help-steps {
  counter-reset: help-step;
}
.help-steps li {
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  align-items: start;
  gap: 9px;
}

.help-step-number {
  display: inline-flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 800;
  color: #4338ca;
  background: #f5f3ff;
}

.help-code {
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #1e293b;
  border-radius: 10px;
  background: #0f172a;
}

.help-code-toolbar {
  display: flex;
  height: 36px;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 0 13px;
  border-bottom: 1px solid #334155;
  background: #1e293b;
}
.help-code-toolbar > span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #94a3b8;
}
.help-code-toolbar button {
  display: inline-flex;
  height: 25px;
  align-items: center;
  gap: 5px;
  padding: 0 8px;
  border: 1px solid #475569;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #cbd5e1;
  background: #0f172a;
  cursor: pointer;
}
.help-code-toolbar button:hover {
  border-color: #818cf8;
  color: #fff;
}

.help-code pre {
  margin: 0;
  overflow-x: auto;
  padding: 16px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  line-height: 1.7;
  color: #e2e8f0;
  tab-size: 4;
  white-space: pre;
}

.help-callout {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  gap: 9px;
  border: 1px solid;
  border-radius: 10px;
}
.help-callout > i {
  margin-top: 1px;
  font-size: 18px;
}
.help-callout strong {
  display: block;
  font-size: 11px;
  font-weight: 800;
}
.help-callout p {
  margin: 3px 0 0;
  font-size: 11px;
  line-height: 1.65;
}

.help-callout-warning {
  margin-bottom: 15px;
  padding: 12px 14px;
  border-color: #fecaca;
  color: #991b1b;
  background: #fef2f2;
}

.help-callout-note {
  margin-top: 15px;
  padding: 12px 14px;
  border-color: #bae6fd;
  color: #075985;
  background: #f0f9ff;
}

.help-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 18px;
  padding: 13px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.75);
}
.help-tags span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 650;
  color: #64748b;
  background: #f1f5f9;
}
.help-tags span:first-child {
  padding-left: 0;
  color: #475569;
  background: transparent;
}

.help-document-nav {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  margin-top: 16px;
}
.help-document-nav button {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  padding: 13px 15px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #475569;
  background: #fff;
  cursor: pointer;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.help-document-nav button:hover {
  border-color: #a5b4fc;
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.08);
}
.help-document-nav button > i {
  flex: 0 0 auto;
  font-size: 20px;
  color: #6366f1;
}
.help-document-nav button > span {
  min-width: 0;
}
.help-document-nav button small,
.help-document-nav button strong {
  display: block;
}
.help-document-nav button small {
  font-size: 9px;
  color: #94a3b8;
}
.help-document-nav button strong {
  margin-top: 2px;
  overflow: hidden;
  font-size: 11px;
  font-weight: 700;
  color: #334155;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.help-document-nav button.is-next {
  justify-content: flex-end;
  text-align: right;
}

.help-nav-placeholder {
  min-height: 1px;
}

.help-empty-article {
  height: 100%;
  min-height: 360px;
  padding: 30px;
}
.help-empty-article > i {
  font-size: 52px;
}
.help-empty-article h2 {
  margin: 14px 0 0;
  font-size: 17px;
}
.help-empty-article p {
  margin: 7px 0 15px;
  font-size: 12px;
}
.help-empty-article button {
  padding: 9px 13px;
  font-size: 11px;
}

@media (max-width: 1080px) {
  .help-page {
    height: auto;
    min-height: 100%;
    overflow: visible;
  }
  .help-hero {
    align-items: stretch;
    flex-direction: column;
    gap: 18px;
  }
  .help-search-wrap {
    width: 100%;
  }
  .help-body {
    display: block;
    min-height: auto;
  }
  .help-sidebar {
    overflow: visible;
    border-right: 0;
    border-bottom: 1px solid var(--help-border);
  }
  .help-sidebar-section {
    padding: 14px 20px;
  }
  .help-category {
    display: inline-grid;
    width: calc(50% - 4px);
    margin-right: 4px;
    vertical-align: top;
  }
  .help-document-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }
  .help-document-list .help-sidebar-heading,
  .help-document-list .help-empty-list {
    grid-column: 1/-1;
  }
  .help-guide-item {
    margin-top: 0;
  }
  .help-article-shell {
    overflow: visible;
  }
}
@media (max-width: 640px) {
  .help-hero {
    padding: 20px 16px 18px;
  }
  .help-hero-copy h1 {
    font-size: 21px;
  }
  .help-category {
    width: 100%;
    margin-right: 0;
  }
  .help-document-list {
    display: block;
  }
  .help-guide-item {
    margin-top: 4px;
  }
  .help-article {
    width: calc(100% - 24px);
    padding: 18px 0 30px;
  }
  .help-article-header,
  .help-section {
    padding: 20px 18px;
  }
  .help-visual-toolbar {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
    padding: 10px 13px;
  }
  .help-visual-toolbar {
    flex-wrap: wrap;
  }
  .help-visual-hint {
    display: block;
  }
  .help-visual-canvas {
    overflow-x: auto;
    justify-content: flex-start;
    padding: 10px;
  }
  .help-visual-canvas img {
    width: 760px;
    max-width: none;
  }
  .help-visual figcaption {
    padding: 10px 13px 12px;
  }
  .help-article-heading {
    align-items: flex-start;
  }
  .help-article-heading h2 {
    font-size: 20px;
  }
  .help-article-icon {
    width: 42px;
    height: 42px;
    border-radius: 11px;
    font-size: 21px;
  }
  .help-source {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .help-source code {
    width: 100%;
    white-space: normal;
    word-break: break-all;
  }
  .help-document-nav {
    grid-template-columns: 1fr;
  }
  .help-nav-placeholder {
    display: none;
  }
}
@media (max-width: 1080px) {
  .help-tabs {
    padding: 0 20px;
  }
  .help-tree {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 12px;
  }
  .help-tree .help-sidebar-heading,
  .help-tree .help-empty-list {
    grid-column: 1/-1;
  }
  .help-tree-group {
    margin-top: 0;
    padding: 4px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #fff;
  }
}
@media (max-width: 640px) {
  .help-tabs {
    padding: 0 10px;
  }
  .help-tab {
    height: 44px;
    padding: 0 10px;
  }
  .help-tree {
    display: block;
  }
  .help-tree-group {
    margin-top: 7px;
  }
}
.help-manual-panel {
  margin: 1rem 0;
  padding: 1rem;
  background: white;
  border: 1px solid #d4d4d8;
  border-radius: 0.75rem;
}

:host ::ng-deep .help-manual {
  overflow-wrap: anywhere;
  max-height: 75vh;
  overflow: auto;
  padding: 1rem;
  line-height: 1.7;
}
:host ::ng-deep .help-manual h1, :host ::ng-deep .help-manual h2, :host ::ng-deep .help-manual h3, :host ::ng-deep .help-manual h4 {
  font-weight: 600;
  margin: 1.25rem 0 0.5rem;
}
:host ::ng-deep .help-manual h1 {
  font-size: 1.5rem;
}
:host ::ng-deep .help-manual h2 {
  font-size: 1.25rem;
}
:host ::ng-deep .help-manual h3 {
  font-size: 1.1rem;
}
:host ::ng-deep .help-manual p, :host ::ng-deep .help-manual ul, :host ::ng-deep .help-manual ol, :host ::ng-deep .help-manual pre, :host ::ng-deep .help-manual table {
  margin: 0.75rem 0;
}
:host ::ng-deep .help-manual ul {
  list-style: disc;
  padding-left: 1.5rem;
}
:host ::ng-deep .help-manual ol {
  list-style: decimal;
  padding-left: 1.5rem;
}
:host ::ng-deep .help-manual pre {
  overflow: auto;
  padding: 0.75rem;
  background: #f4f4f5;
  white-space: pre;
}
:host ::ng-deep .help-manual table {
  display: block;
  overflow: auto;
}
:host ::ng-deep .help-manual td, :host ::ng-deep .help-manual th {
  padding: 0.4rem;
  border: 1px solid #d4d4d8;
}
:host ::ng-deep .help-manual a {
  color: #4338ca;
  text-decoration: underline;
}
:host ::ng-deep .help-manual img {
  max-width: 100%;
}

/* Keep the full manual and its dense diagrams within their own scroll regions. */
.help-manual-panel {
  flex: 0 0 auto;
  max-height: 52vh;
  overflow: auto;
}

.help-manual-language {
  margin: 8px 0;
  color: #64748b;
  font-size: 12px;
}

:host ::ng-deep .help-manual {
  max-height: 42vh;
}
:host ::ng-deep .help-manual .help-manual-figure {
  min-width: 0;
  max-width: 100%;
  margin: 18px 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
:host ::ng-deep .help-manual .help-manual-figure > a {
  display: block;
  padding: 8px 12px;
  text-align: right;
  font-size: 12px;
  background: #f8fafc;
}
:host ::ng-deep .help-manual .help-manual-image-canvas {
  overflow-x: auto;
  padding: 10px;
}
:host ::ng-deep .help-manual .help-manual-image-canvas img {
  display: block;
  width: 100%;
  min-width: 760px;
  max-width: none;
  height: auto;
}

/* Fit diagrams first; let readers opt into a larger, scrollable view. */
.help-visual-toolbar {
  flex-wrap: wrap;
}

.help-visual-zoom {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 8px;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  color: #4338ca;
  background: #fff;
  font-size: 11px;
  cursor: pointer;
}

.help-visual-canvas {
  min-width: 0;
  overflow-x: auto;
}

.help-visual-canvas img {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  flex: 0 0 auto;
}

.help-visual-canvas.is-expanded {
  justify-content: flex-start;
}

.help-visual-canvas.is-expanded img {
  width: 1200px;
  min-width: 1200px;
  max-width: none;
}

:host ::ng-deep .help-manual .help-manual-image-canvas img {
  min-width: 0;
  max-width: 100%;
}

@media (max-width: 640px) {
  .help-visual-toolbar {
    flex-direction: row;
    align-items: center;
    gap: 7px;
  }
  .help-visual-toolbar > span, .help-visual-hint {
    width: 100%;
  }
  .help-visual-canvas.is-expanded img {
    width: 760px;
    min-width: 760px;
  }
}`],
})
export class PageKieraHelpComponent implements OnInit {
    public expandedVisuals: { [asset: string]: boolean } = {};
    public async toggleVisual(visual: HelpVisual) {
        this.expandedVisuals[visual.asset] = !this.expandedVisuals[visual.asset];
        await this.service.render();
    }
    public manualOpen = false;
    public manualHtml = '';
    public manualError = '';
    public manualLoading = false;
    public async toggleManual() {
        this.manualOpen = !this.manualOpen;
        if (this.manualOpen && !this.manualHtml && !this.manualLoading) {
            this.manualLoading = true;
            this.manualError = '';
            await this.service.render();
            try {
                const res = await wiz.call('manual');
                if (res.code !== 200 || !res.data?.markdown) throw new Error();
                const converter = new showdown.Converter({ tables: true, strikethrough: true, ghCodeBlocks: true });
                const document = new DOMParser().parseFromString(converter.makeHtml(res.data.markdown), 'text/html');
                document.querySelectorAll('img[src], a[href]').forEach((element) => {
                    const attribute = element.tagName === 'IMG' ? 'src' : 'href';
                    const source = element.getAttribute(attribute) || '';
                    if (source.startsWith('../src/assets/')) {
                        element.setAttribute(attribute, '/assets/' + source.slice('../src/assets/'.length));
                    }
                });

                const manualDocuments: { [name: string]: string } = {"WIZ_KiERA_전체_기능_체크리스트.md":"features","WIZ_KiERA_도움말_시각화_자료.md":"visuals","WIZ_KiERA_도움말_확장_시각화_준비안.md":"expansion","WIZ_KiERA_도움말_현행_구조_반영_검토_체크리스트.md":"structure","../infra/kiera-backup/README.md":"backup"};
                document.querySelectorAll('a[href]').forEach((anchor) => {
                    const href = anchor.getAttribute('href') || '';
                    const [name, fragment] = href.split('#', 2);
                    if (manualDocuments[name]) {
                        anchor.setAttribute('href', '/assets/help/manual/' + manualDocuments[name] + '.html' + (fragment ? '#' + fragment : ''));
                        anchor.setAttribute('target', '_blank');
                        anchor.setAttribute('rel', 'noopener noreferrer');
                    } else if (href.startsWith('../artifacts/') || href.startsWith('../devlog/')) {
                        const label = document.createElement('span');
                        label.textContent = (anchor.textContent || '') + ' (내부 검증 기록)';
                        anchor.replaceWith(label);
                    }
                });
                document.querySelectorAll('img').forEach((img) => {
                    const source = img.getAttribute('src') || '';
                    if (!source.startsWith('/assets/help/')) return;
                    const figure = document.createElement('figure');
                    figure.className = 'help-manual-figure';
                    const canvas = document.createElement('div');
                    canvas.className = 'help-manual-image-canvas';
                    const original = document.createElement('a');
                    original.href = source;
                    original.target = '_blank';
                    original.rel = 'noopener noreferrer';
                    original.textContent = this.service.lang.localize('원본 보기');
                    img.replaceWith(figure);
                    canvas.appendChild(img);
                    figure.appendChild(original);
                    figure.appendChild(canvas);
                });
                this.manualHtml = document.body.innerHTML;
            } catch (_) { this.manualError = await this.service.lang.translate('gap.manual.error');
            } finally { this.manualLoading = false; }
        }
        await this.service.render();
    }

    public visualAssetCount: number = 42;
    public categories: HelpCategory[] = [
        { id: 'start', title: '시작하기', description: '초기 구성과 화면 사용법', icon: 'bx bx-compass' },
        { id: 'resources', title: '자원 관리', description: '노드와 인프라 자원 구성', icon: 'bx bx-cube' },
        { id: 'provisioning', title: '배포 · 프로비저닝', description: '이미지와 클러스터 배포', icon: 'bx bx-cloud-upload' },
        { id: 'operations', title: '운영 · 장애 대응', description: '점검, 로그, 문제 해결', icon: 'bx bx-pulse' },
        { id: 'admin', title: '관리 · 개발', description: '권한, API, 빌드와 테스트', icon: 'bx bx-cog' },
    ];

    public guides: HelpGuide[] = [
        {
            id: 'overview',
            category: 'start',
            title: 'WIZ KiERA 소개',
            summary: '베어메탈 자원 등록부터 클러스터 배포와 운영 점검까지 KiERA가 제공하는 기능을 살펴봅니다.',
            icon: 'bx bx-book-open',
            audience: '전체 사용자',
            path: '/kiera',
            tags: ['개요', '베어메탈', '클러스터', '프로비저닝'],
            sections: [
                {
                    title: 'KiERA에서 할 수 있는 일',
                    bullets: [
                        'BMC Discovery로 장비를 탐색하고 Add·CSV·API의 별도 등록 경로로 노드를 추가합니다.',
                        'Rack, Zone, Group, Chassis, Cluster 단위로 자원을 구성하고 상태를 확인합니다.',
                        '사전 설치 환경, OS 이미지, 배포 스크립트와 네트워크 정책을 관리합니다.',
                        '직접 배포 또는 Relay 기반 배포를 실행하고 작업·로그·모니터링 결과를 추적합니다.',
                        'SSH 터미널, IPMI SOL, Zabbix와 점검 도구를 이용해 운영 상태를 확인합니다.',
                    ],
                },
                {
                    title: '기본 작업 흐름',
                    steps: [
                        '관리 설정과 사용자 권한을 확인합니다.',
                        'BMC Credentials와 Subnet을 구성합니다.',
                        'BMC Discovery로 장비를 찾은 뒤 노드 Add/CSV 또는 API 등록으로 노드를 추가합니다.',
                        '노드의 네트워크·스토리지·장치 정보를 확인하고 그룹과 클러스터를 구성합니다.',
                        '이미지와 스크립트를 준비한 뒤 클러스터 배포를 실행합니다.',
                        '작업 관리, 서비스 로그, 검사와 모니터링에서 결과를 확인합니다.',
                    ],
                },
                {
                    title: '도움말 사용법',
                    paragraphs: [
                        '왼쪽 분류와 검색을 이용하면 현재 화면과 작업 목적에 맞는 문서를 찾을 수 있습니다.',
                        '각 문서의 관련 화면 버튼을 누르면 설명한 기능으로 바로 이동합니다. 실제로 보이는 메뉴와 버튼은 로그인한 사용자의 권한에 따라 달라집니다.',
                    ],
                },
            ],
        },
        {
    "id": "account-session",
    "category": "start",
    "title": "로그인·내 프로필·세션",
    "summary": "로그인과 로그아웃, 본인 정보·비밀번호 변경 및 세션 만료 시 확인할 내용을 안내합니다.",
    "icon": "bx bx-user-circle",
    "audience": "전체 사용자",
    "path": "/mypage",
    "tags": [
        "로그인",
        "로그아웃",
        "비밀번호",
        "프로필",
        "Session",
        "Login",
        "Logout"
    ],
    "sections": [
        {
            "title": "접속과 로그인",
            "steps": [
                "운영자가 안내한 HTTPS 주소의 /access에서 발급받은 계정으로 로그인합니다. 공개 도메인과 설치 서버의 3001 HTTPS 주소는 환경에 맞게 사용합니다.",
                "로그인 실패 시 주소·계정·키보드 입력을 확인합니다. 화면이 열리지 않으면 연결·인증서·서버 상태를 먼저 확인하고 계정 문제와 구분합니다.",
                "로그인 후 역할에 따라 보이는 메뉴가 다릅니다. 필요한 메뉴가 없으면 관리자에게 기능 권한을 확인합니다."
            ]
        },
        {
            "title": "내 프로필과 비밀번호 변경",
            "steps": [
                "사이드바 아래 프로필을 누르거나 /mypage로 이동해 이름·연락처를 수정하고 저장 결과를 확인합니다. 로그인 이메일과 역할은 이 폼에서 바꾸지 않습니다.",
                "로컬 비밀번호가 있는 계정은 현재 비밀번호를 입력하고 새 비밀번호와 확인값을 일치시킵니다. 로컬 비밀번호가 없는 계정은 화면의 별도 안내를 따릅니다.",
                "새 비밀번호는 10자 이상이며 대문자·소문자·숫자·특수문자 중 두 종류 이상을 포함해야 합니다. 오류가 나면 입력값을 확인하고 성공 메시지 뒤 폼이 비워졌는지 확인합니다."
            ],
            "warning": "실제 비밀번호를 도움말 예제·채팅·캡처에 남기지 않습니다. 다른 사용자의 계정 변경은 사용자 관리의 별도 권한과 절차를 따릅니다."
        },
        {
            "title": "로그아웃과 세션 만료",
            "bullets": [
                "공유 기기에서는 사이드바 아래 로그아웃을 눌러 종료합니다. 브라우저 창을 닫는 것만으로 로그아웃을 대신하지 않습니다.",
                "세션 만료나 401 응답으로 로그인 화면으로 돌아오면 다시 로그인합니다. 저장·배포 요청을 반복하기 전에 목록·Jobs·노드 상태에서 직전 요청 결과를 확인합니다.",
                "통신이 끊겨도 이미 접수한 작업은 서버에서 계속될 수 있습니다. 연결 복구 후 같은 작업 ID로 확인하고 중복 실행을 피합니다."
            ]
        }
    ]
},
        {
            id: 'initial-setup',
            category: 'start',
            title: '설치 후 초기 구성',
            summary: 'WIZ KiERA에 처음 접속한 뒤 운영을 시작하기 전에 준비해야 할 설정 순서입니다.',
            icon: 'bx bx-slider-alt',
            audience: '관리자',
            path: '/kiera/management-settings',
            tags: ['설치', '초기 설정', '관리 설정', '체크리스트'],
            sections: [
                {
                    title: '접속과 계정 확인',
                    steps: [
                        '발급받은 계정으로 로그인하고 역할과 접근 가능한 메뉴를 확인합니다.',
                        '관리자는 사용자 관리에서 운영 담당자별 역할을 확인합니다.',
                        '메뉴가 보이지 않으면 사이드바 정책의 read 권한을 먼저 점검합니다.',
                    ],
                },
                {
                    title: '필수 운영 정보 준비',
                    bullets: [
                        'BMC 접속에 사용할 IPMI 또는 Redfish 자격증명',
                        '관리망·프로비저닝망·스토리지망의 Subnet과 인터페이스 정보',
                        '노드에 배포할 사전 설치 환경과 OS 이미지',
                        '필요한 배포 전·후 스크립트와 첨부파일',
                        '직접 배포 또는 Relay 배포 방식과 대상 클러스터',
                        'Zabbix, Lustre, Juju 등 사용할 외부 연동 정보',
                    ],
                },
                {
                    title: '초기 구성 권장 순서',
                    steps: [
                        '관리 설정에서 현재 환경값을 검토합니다.',
                        'BMC Credentials에 공통 자격증명 프로필을 등록합니다.',
                        'Subnet에서 서버 인터페이스를 스캔하고 사용할 네트워크를 등록합니다.',
                        '사전 설치 환경과 이미지를 등록하고 파일 상태를 확인합니다.',
                        '테스트 장비 한 대를 탐색·등록해 전원 조회와 노드 상세 정보를 확인합니다.',
                        '검사 화면의 기본 점검을 실행한 후 실제 클러스터 구성을 시작합니다.',
                    ],
                    warning: '초기 구성 중 서비스 설정이나 네트워크 파일을 적용하는 작업은 현재 운영 트래픽에 영향을 줄 수 있습니다. 변경 범위와 복구 방법을 확인한 뒤 실행하세요.',
                },
            ],
        },
        {
            id: 'navigation-permissions',
            category: 'start',
            title: '화면 탐색과 권한',
            summary: '사이드바 분류, 다국어 전환과 역할별 메뉴 노출 방식을 설명합니다.',
            icon: 'bx bx-menu',
            audience: '전체 사용자',
            path: '/kiera',
            tags: ['사이드바', '권한', '역할', '언어'],
            sections: [
                {
                    title: '사이드바 분류',
                    bullets: [
                        '자원 관리: Rack View, Zone/Rack 관리, BMC Credentials, 그룹, 노드, Chassis 관리, 클러스터',
                        '배포 / 프로비저닝: Rack View, 작업 실행, 클러스터 배포, 스크립트 설정, 이미지, DiskLess Image Linux, 사전 설치 환경',
                        '네트워크 / 탐색: 서브넷과 BMC Discovery',
                        "운영 / 점검: Rack View, 작업 관리, 서비스 로그, 검사, SSH Access Management, Cluster User Management",
                        '외부 연동: Zabbix, Lustre, Juju',
                        "관리 / 지원: 사용자 관리, 디버그, 로그 정책, 관리 설정, AI 챗봇, 도움말",
                    ],
                },
                {
                    title: '권한에 따른 차이',
                    paragraphs: ['메뉴와 기능 버튼은 사용자 역할뿐 아니라 기능별 read, create, update, remove, execute 권한으로 필터링됩니다.'],
                    bullets: [
                        '메뉴가 없으면 해당 기능의 read 권한을 확인합니다.',
                        '버튼이 숨겨지면 action 권한을, 버튼이 보이지만 비활성화되면 권한과 함께 필수 입력·대상 선택·처리 중 상태를 확인합니다.',
                        '관리 설정, 로그 정책, 사용자 관리는 superadmin에게만 보일 수 있습니다.',
                        'API 노드 등록과 일부 운영 기능은 admin 이상에서만 제공될 수 있습니다.',
                        '주소를 직접 입력해도 Spring PermissionGuard 또는 API 권한 검사가 최종적으로 요청을 거부할 수 있습니다.',
                    ],
                },
                {
                    title: '화면 이동 팁',
                    bullets: [
                        '목록 행을 선택하면 노드·클러스터·배포 상세 화면으로 이동합니다.',
                        '상세 화면의 URL 탭이 바뀌어도 같은 객체의 정보를 이어서 확인할 수 있습니다.',
                        'Swagger는 새 탭으로 열리며 공개 API 권한이 필요합니다.',
                    ],
                },
                {
                    title: '한·영 전환',
                    bullets: [
                        '사이드바의 언어 전환으로 등록된 화면·공통 모달·도움말의 정적 문구와 표준 상태·역할·유형 값을 한국어 또는 영어로 바꿉니다. 도움말 도식과 원본 이미지 보기 링크도 선택한 언어를 따릅니다.',
                        '장비 이름, 사용자 입력, 로그 원문과 서버가 반환하는 자유 형식 데이터는 식별·증거 보존을 위해 번역하지 않습니다.',
                        '전환 뒤 일부 문구만 이전 언어로 남으면 새로고침 전에 같은 화면의 동적 데이터인지 확인하고, 정적 UI 문구라면 화면 경로와 문구를 기록해 보고합니다.',
                    ],
                },
                {
                    "title": "표시 언어와 사용자 데이터",
                    "note": "한·영 전환은 UI 문구에 적용합니다. 장비명·주소·파일명·자유 로그·채팅 원문은 원본을 유지하고, OPA·IPoIB·Lustre 같은 기술명은 번역하지 않습니다."
                },
            ],
        },
        {
            id: 'rack-zone',
            category: 'resources',
            title: 'Rack과 Zone 구성',
            summary: '물리 위치를 Zone과 Rack으로 정의하고 Rack View에서 장비 배치를 확인합니다.',
            icon: 'bx bx-layout',
            audience: '자원 관리자',
            path: '/kiera/zones',
            tags: ['Zone', 'Rack', '위치', 'Rack View'],
            sections: [
                {
                    title: '구성 원칙',
                    bullets: [
                        'Zone은 데이터센터, 전산실 또는 운영 구역처럼 상위 물리 영역을 나타냅니다.',
                        'Rack은 Zone 아래 실제 랙 또는 논리적 배치 단위를 나타냅니다.',
                        '노드와 Chassis에 위치를 지정하면 Rack View에서 상태와 점유 위치를 함께 볼 수 있습니다.',
                    ],
                },
                {
                    title: '권장 작업 순서',
                    steps: [
                        'Zone 이름과 식별 기준을 정합니다.',
                        '각 Zone에 Rack을 등록하고 실제 위치와 일치하는지 확인합니다.',
                        'Chassis와 노드에 Rack·Unit 정보를 연결합니다.',
                        '자원 관리 Rack View에서 중복 배치와 위치 미지정 자원을 확인합니다.',
                    ],
                },
                {
                    title: '운영 팁',
                    note: '배포 상태 확인에는 프로비저닝 Rack View, 장애와 가동 상태 확인에는 운영 Rack View를 함께 사용하면 자원의 목적별 상태를 빠르게 비교할 수 있습니다.',
                },
            ],
        },
        {
    "id": "bmc-credentials",
    "category": "resources",
    "title": "BMC Credentials 관리",
    "summary": "IPMI 또는 Redfish 접속 정보를 재사용 가능한 프로필로 안전하게 관리합니다.",
    "icon": "bx bx-key",
    "audience": "자원 관리자",
    "path": "/kiera/bmc-credentials",
    "tags": [
        "BMC",
        "IPMI",
        "Redfish",
        "Credentials"
    ],
    "sections": [
        {
            "title": "프로필 구성",
            "bullets": [
                "운영자가 구분할 수 있는 프로필 이름을 지정합니다.",
                "장비가 지원하는 IPMI 또는 Redfish 프로토콜을 선택합니다.",
                "Redfish는 HTTPS를 사용합니다. TLS를 켜면 인증서와 호스트 이름을 검증하며, timeout·retries도 Profile 설정에 따라 적용합니다.",
                "사용자명과 비밀번호를 저장한 뒤 대상 장비에서 접속 테스트합니다."
            ]
        },
        {
            "title": "사용 위치",
            "bullets": [
                "BMC Discovery에서 네트워크 스캔용 프로필로 선택합니다.",
                "노드 상세에서 자격증명 프로필을 연결하고 BMC 상태를 재확인합니다.",
                "전원 제어, 부팅 장치 설정과 SOL 연결에 같은 프로필이 사용될 수 있습니다."
            ]
        },
        {
            "title": "보안과 변경",
            "warning": "공용 프로필을 변경하면 여러 노드의 전원·부팅 제어에 영향을 줄 수 있습니다. 비밀번호 교체 전 적용 대상과 롤백 프로필을 확인하세요.",
            "bullets": [
                "개인별 비밀번호 대신 장비 그룹별 서비스 계정을 사용합니다.",
                "최소 권한과 정기 교체 정책을 적용합니다.",
                "문서, 로그, 스크립트에 실제 비밀번호를 남기지 않습니다."
            ]
        },
        {
            "title": "저장값과 현재 적용 범위",
            "warning": "Spring Discovery는 Profile의 timeout·retries를 적용합니다. Redfish는 항상 HTTPS를 사용하며 tls 값은 인증서·호스트 이름 검증 여부를 제어합니다.",
            "note": "화면 저장 성공을 연결 보안 정책 적용 성공으로 판단하지 말고 대표 장비의 실제 연결 결과와 서비스 로그를 확인하세요."
        },
        {
            "title": "명령 결과 확인",
            "bullets": [
                "일반 Actions의 전원·부팅 변경은 명령 수락 뒤 상태를 최대 4회 재조회해 요청값을 확인합니다. 실측 전원과 verified 결과를 확인하며, 명령 수락만으로 완료로 판단하지 않습니다.",
                "작업 뒤 Current Power Status·Current Boot Device를 직접 조회해 요청한 상태와 비교합니다."
            ]
        }
    ]
},
        {
            id: 'node-registration',
            category: 'resources',
            title: '노드 검색과 등록',
            summary: 'BMC Discovery로 장비를 찾고 노드 Add/CSV 또는 API 등록으로 KiERA 자원에 추가합니다.',
            icon: 'bx bx-radar',
            audience: '자원 관리자',
            path: '/kiera/bmc-discovery',
            tags: ['노드 등록', 'BMC Discovery', 'API 등록', '검색'],
            sections: [
                {
                    title: 'BMC Discovery',
                    steps: [
                        '검색할 IP 주소 또는 범위를 입력합니다.',
                        'Password가 저장된 BMC Credential Profile을 선택합니다.',
                        'Discovery를 실행하고 검색된 제조사, 모델, 주소와 연결 상태를 확인합니다.',
                        '이미 등록된 노드는 결과에서 제외되므로 기존 노드 목록도 함께 확인합니다.',
                        '선택 항목을 노드로 등록하면 장비별 Node를 생성합니다. 이미 등록된 BMC 주소는 건너뛰며 실패 사유를 확인할 수 있습니다. BMC MAC을 프로비저닝 NIC의 MAC으로 복사하지 않습니다.',
                    ],
                },
                {
                    title: '검색 결과에서 할 수 있는 작업',
                    bullets: [
                        '현재 전원 상태와 부팅 장치를 조회합니다.',
                        'PXE 또는 Local Disk 부팅 모드를 UEFI/Legacy 기준으로 지정합니다.',
                        'Power On, Soft/Force Off, Reset 등 허용된 전원 작업을 실행합니다.',
                        '잘못 검색된 결과를 선택해 정리합니다.',
                    ],
                    warning: '부팅 장치 변경과 전원 제어는 대상 장비의 실행 중 작업에 영향을 줍니다. 장비 식별값과 선택 항목을 다시 확인하세요.',
                },
                {
                    title: 'CSV 등록과 내보내기',
                    bullets: [
                        '노드 CSV는 공통 등록 정보 29열을 사용하며 Ethernet 4개와 InfiniBand 2개의 이름·IP·MAC을 포함합니다. CPU·디스크 인벤토리는 수집 후 확인합니다.',
                        'BMC Credentials에서 Default를 지정하면 CSV의 빈 bmc_credential_name에 적용됩니다. 기본값을 선택하지 않았으면 BMC 미할당으로 등록합니다.',
                        '빈 Group은 기본 그룹 또는 미할당 그룹, 빈 Rack·Unit은 미할당, 빈 rack_size는 1U로 처리합니다. 인터페이스 이름이 비어 있으면 자동 이름을 쓰며 유효한 커미션 수집 결과가 오면 실제 이름으로 교체합니다.',
                    ],
                },
                {
                    title: 'API 노드 등록',
                    paragraphs: ['대량 연동 또는 외부 시스템에서 등록할 때는 API 노드 등록 화면과 공개 API 계약을 사용합니다. API 작업은 관리자 권한과 중복 식별자 검증이 필요합니다.'],
                    bullets: [
                        'SSH 스캔 후 등록하면 연결·장비 수집·저장·KiERA Agent·Zabbix Agent·완료 단계를 확인합니다. 최종 완료는 등록 트랜잭션이 커밋된 뒤 표시합니다.',
                        '진행 연결이 끊겼으면 노드 목록에서 저장 결과를 먼저 확인합니다. Agent 설치 경고와 노드 등록 실패를 구분합니다.',
                        '등록 응답은 KiERA·Zabbix Agent 설치 스크립트를 제공합니다. SSH와 설치 옵션을 지정하면 실제로 실행하고 installed 결과를 반환합니다.',
                        'Zabbix는 기존 정상 Agent를 재사용하며 신규 설치는 제공된 Ubuntu 22.04·CentOS 7 오프라인 패키지를 사용합니다. 다른 OS는 별도 설치 후 상태를 확인합니다.',
                    ],
                    note: '등록 성공은 노드 목록과 저장된 식별자로 확인합니다. BMC 연결·하드웨어 수집·Agent heartbeat는 구성과 Agent 설치 여부에 따라 별도로 검증하며, 등록 자체의 필수 완료 조건은 아닙니다.',
                },
            ],
        },
        {
            id: 'node-management',
            category: 'resources',
            title: '노드 상세 관리',
            summary: '노드의 상태, 네트워크, 스토리지, 장치, 이력과 모니터링 정보를 확인하고 수정합니다.',
            icon: 'bx bx-server',
            audience: '자원 관리자 · 운영자',
            path: '/kiera/nodes',
            tags: ['노드', '네트워크', '스토리지', '장치', '이력'],
            sections: [
                {
                    title: 'Summary',
                    bullets: [
                        'BMC 연결, heartbeat와 프로비저닝 신호를 확인합니다.',
                        'CPU, 메모리, 디스크, 네트워크와 자산 식별 정보를 확인합니다.',
                        'BMC Credential Profile을 연결하고 접속 테스트 또는 재확인을 실행합니다.',
                    ],
                },
                {
                    title: '구성 탭',
                    bullets: [
                        'Network: Ethernet, InfiniBand, Bond, VLAN과 DHCP/Static 정책을 관리합니다.',
                        'Storage: 대상 디스크, 파일시스템과 배포에 사용할 스토리지 구성을 관리합니다.',
                        'Devices: 수집된 PCI 장치와 하드웨어 정보를 확인합니다.',
                        'Zabbix: 에이전트 연결과 모니터링 등록 상태를 확인합니다.',
                    ],
                    note: '확장 하드웨어 카드는 화면이 중첩 hardware_summary 형식을 기대하지만 현재 Spring 응답은 평면 형식이어서 실제 수집 데이터가 있어도 미수집으로 보일 수 있습니다. 이 경우 Devices 원본과 서비스 응답을 함께 확인하세요.',
                },
                {
                    title: '이력과 타임라인',
                    bullets: [
                        'History에서 배포 방식, 상태와 실행 기록을 필터링합니다.',
                        'Timeline에서 배포, Commissioning, PXE 이벤트를 기간별로 확인합니다.',
                        '로그 정책에 따라 History 또는 Timeline 탭이 표시되지 않을 수 있습니다.',
                    ],
                },
                {
                    title: '변경 전 확인',
                    warning: '네트워크·스토리지 변경은 다음 배포에서 노드 접속 불가나 데이터 손실로 이어질 수 있습니다. 현재 배포 상태와 대상 장치를 확인하고 변경하세요.',
                },
                {
                    title: '자료가 비어 있을 때',
                    note: "하드웨어 수집 시각과 이력 수집 정책을 먼저 확인합니다. 현재 deploy_log와 작업 저널은 정책에 따라 기록되며, 과거 누락 이력은 복원되지 않습니다. Jobs·Timeline·PXE 로그를 같은 노드와 시각으로 대조하세요.",
                },
            ],
        },
        {
            id: 'resource-grouping',
            category: 'resources',
            title: 'Group, Chassis, Cluster 구성',
            summary: '노드를 목적과 물리 구조에 따라 그룹화하고 배포 가능한 클러스터로 구성합니다.',
            icon: 'bx bx-network-chart',
            audience: '자원 관리자',
            path: '/kiera/clusters',
            tags: ['Group', 'Chassis', 'Cluster', '템플릿'],
            sections: [
                {
                    title: '각 구성요소의 역할',
                    bullets: [
                        'Group: 용도, 소유 조직 또는 운영 정책이 같은 노드를 묶는 논리 단위',
                        'Chassis: 다수 노드를 포함하는 물리 섀시와 슬롯 구조를 나타내는 단위',
                        'Cluster: 실제 배포와 운영의 대상이 되는 노드 집합과 역할 구성',
                    ],
                },
                {
                    title: '클러스터 구성 절차',
                    steps: [
                        '대상 노드의 위치, BMC와 네트워크 상태를 먼저 확인합니다.',
                        '클러스터 이름, 유형과 배포 방식을 정합니다.',
                        '노드를 역할 또는 배포 그룹에 배치합니다.',
                        'Relay 방식이면 Relay와 Compute 역할, Subnet 연결을 확인합니다.',
                        '구성 결과를 저장한 뒤 클러스터 배포 화면에서 준비 상태를 확인합니다.',
                    ],
                },
                {
                    title: '구성 품질 점검',
                    bullets: [
                        '하나의 노드가 충돌하는 배포 대상에 중복 포함되지 않습니다.',
                        '직접 배포는 대상 노드 구성을, Relay 배포는 Head와 Authority/Member Relay 및 Compute 배정을 각각 확인합니다.',
                        '노드의 아키텍처와 사용할 이미지가 일치합니다.',
                        '각 노드가 사용할 Subnet과 BMC Credentials가 연결됐습니다.',
                    ],
                },
                {
                    title: '현재 적용 범위',
                    bullets: [
                        'Cluster CSV는 공통 노드 29열에 role·dhcp_group_key·relay_hostname을 더한 32열을 사용합니다. 기존 노드는 매칭하고 없는 노드는 등록하며 인터페이스와 Relay 담당 관계를 저장합니다.',
                        '수동 생성 wizard는 중첩 Group·Rack·Zone·Node include/exclude 필터와 relay_config를 적용합니다. 역할과 Compute 담당 Relay의 유효성을 확인합니다.',
                        '여러 열을 가진 Chassis의 slot 표시는 현재 columns=1 계산과 달라질 수 있어 Chassis 상세의 실제 row·column을 함께 확인합니다.',
                    ],
                },
            ],
        },
        {
            id: 'provisioning-flow',
            category: 'provisioning',
            title: '프로비저닝 전체 흐름',
            summary: '배포 준비부터 부팅, 이미지 적용, 상태 보고와 완료 확인까지의 제품 작업 흐름입니다.',
            icon: 'bx bx-git-branch',
            audience: '배포 관리자',
            path: '/kiera/provisioning-rack',
            tags: ['프로비저닝', 'PXE', '배포 흐름', '상태'],
            sections: [
                {
                    title: '준비 단계',
                    steps: [
                        'Subnet과 PXE 상태를 확인합니다.',
                        '사전 설치 환경, OS 이미지와 배포 스크립트를 준비합니다.',
                        '노드의 BMC, 전원, 부팅 모드와 대상 디스크를 확인합니다.',
                        '클러스터와 배포 그룹, 직접/Relay 방식을 확정합니다.',
                    ],
                },
                {
                    title: '실행 단계',
                    steps: [
                        'KiERA가 노드별 배포 정보와 PXE 부팅 구성을 준비합니다.',
                        'BMC를 통해 대상 노드를 PXE로 부팅합니다.',
                        '사전 설치 환경이 하드웨어와 meta-data를 확인합니다.',
                        '선택한 이미지와 네트워크·스토리지 구성을 적용합니다.',
                        '사전·사후 스크립트와 에이전트 준비 작업을 실행합니다.',
                        '노드가 완료 상태를 보고하고 최종 OS로 부팅합니다.',
                    ],
                },
                {
                    title: '추적 위치',
                    bullets: [
                        '프로비저닝 Rack View: 노드별 배포 상태',
                        '클러스터 배포 상세: Deployment, Nodes, Monitoring, Logs',
                        '작업 관리: 백그라운드 작업과 취소 가능 상태',
                        '서비스 로그: 배포 서비스와 인프라 서비스 로그',
                    ],
                },
            ],
        },
        {
            id: 'subnet-pxe',
            category: 'provisioning',
            title: 'Subnet과 PXE 구성',
            summary: '서버 인터페이스를 등록하고 DHCP, NFS와 PXE 부팅 구성을 관리합니다.',
            icon: 'bx bx-transfer-alt',
            audience: '네트워크 관리자 · 배포 관리자',
            path: '/kiera/subnets',
            tags: ['Subnet', 'DHCP', 'NFS', 'PXE', 'InfiniBand'],
            sections: [
                {
                    title: 'Subnet 등록',
                    steps: [
                        'Scan Interfaces에서 서버가 가진 네트워크 인터페이스를 조회합니다.',
                        '인터페이스 주소, CIDR과 Gateway를 확인하고 필요한 망만 등록합니다.',
                        'General 또는 InfiniBand 유형과 HTTP, NFS, NFS over RDMA 전송 방식을 선택합니다.',
                        '필요한 사전 설치 환경과 DHCP 범위, next-server를 연결합니다.',
                    ],
                },
                {
                    title: '구성 관리',
                    bullets: [
                        'DHCP Config에서 현재 생성 결과를 검토하고 설정 파일에 저장합니다.',
                        'NFS Exports에서 이미지 경로와 허용 대역을 검토하고 적용합니다.',
                        'PXE Status에서 부트로더와 관련 서비스 상태를 확인합니다.',
                        'DHCP 설정 저장은 서비스 시작·중지를 자동으로 바꾸지 않으므로 서비스 로그 화면에서 상태를 확인합니다.',
                    ],
                },
                {
                    title: '변경 전 점검',
                    warning: 'DHCP 대역, next-server 또는 NFS 허용 범위를 잘못 적용하면 같은 네트워크의 다른 장비까지 영향을 받을 수 있습니다.',
                    bullets: [
                        '기존 DHCP 서버와 주소 범위가 겹치지 않습니다.',
                        '서버가 선택한 인터페이스의 주소로 실제 수신할 수 있습니다.',
                        '방화벽과 라우팅이 BMC망·프로비저닝망 정책과 일치합니다.',
                    ],
                },
                {
                    title: '저장과 실제 적용 구분',
                    bullets: [
                        'Disable PE Network Config는 화면과 DB에 저장되지만 현재 Spring PXE/Cloud-init은 ip=dhcp를 고정 생성합니다.',
                        'DHCP·NFS·Squid restart flag는 적용 작업에서 읽히지만 저장만으로 서비스 상태가 바뀌지는 않습니다.',
                        '긴 PXE 단계는 DB 상태 열에서 잘릴 수 있으므로 배포 JSONL과 boot log 원문을 우선합니다.',
                    ],
                },
            ],
        },
        {
            id: 'image-management',
            category: 'provisioning',
            title: '이미지 관리',
            summary: 'OS 이미지 유형, 아키텍처, 연결 스크립트와 업로드 상태를 관리합니다.',
            icon: 'bx bx-archive',
            audience: '배포 관리자',
            path: '/kiera/images',
            tags: ['Cloud Image', 'Safe Backup', 'Live Backup', 'Disk-Less'],
            sections: [
                {
                    title: '이미지 유형',
                    bullets: [
                        'Cloud Image: 일반적인 Disk-ful OS 배포에 사용하는 rootfs 이미지',
                        'Safe Backup: Safe Backup 작업으로 생성된 백업 이미지 유형',
                        'Live Backup: Live Backup 이름으로 분류되는 백업 이미지 유형. 현재 Actions 실행은 PXE 재부팅을 거칩니다.',
                        'Disk-Less Linux: 로컬 디스크 설치 없이 네트워크로 부팅하는 이미지',
                    ],
                },
                {
                    title: '등록 정보',
                    bullets: [
                        '표시 이름, amd64/arm64 아키텍처와 Ubuntu/CentOS/Rocky 계열 OS를 지정합니다.',
                        '필요하면 배포 전·후 스크립트와 Disk-Less Linux 이미지를 연결합니다. 이미지 유형 이름만으로 무중단 백업이나 모든 설정의 부팅 적용을 보장하지 않습니다.',
                        '업로드 진행률과 파일명을 확인하고 완료 전 화면을 닫지 않습니다.',
                    ],
                },
                {
                    title: '배포 전 검증',
                    steps: [
                        '이미지의 출처, 버전, 크기와 해시를 기록합니다.',
                        '대상 노드의 아키텍처와 부팅 모드를 확인합니다.',
                        '테스트 노드에 먼저 배포해 부팅, 네트워크와 SSH를 확인합니다.',
                        'Relay 배포에 사용할 이미지는 Relay 측 동기화 상태도 확인합니다.',
                    ],
                    warning: '이미지 안에 고정 IP, 개인키, 토큰, machine-id 또는 운영 로그가 포함되지 않았는지 확인하세요.',
                },
                {
                    title: '운영자가 확인할 항목',
                    note: '그림의 출처·크기·해시·테스트 배포는 운영자 점검 순서입니다. 업로드만으로 이 검사가 모두 자동 수행되거나 복원 성공이 보장되는 것은 아닙니다.',
                },
            ],
        },
        {
            id: 'pe-diskless',
            category: 'provisioning',
            title: '사전 설치 환경과 Disk-Less',
            summary: 'PXE 부팅에 필요한 사전 설치 환경과 DiskLess Image Linux 원본을 관리합니다.',
            icon: 'bx bx-layer',
            audience: '배포 관리자 · 이미지 개발자',
            path: '/kiera/pe',
            tags: ['PE', '사전 설치', 'DiskLess', 'kernel', 'initrd'],
            sections: [
                {
                    title: '사전 설치 환경',
                    paragraphs: ['사전 설치 환경은 운영 OS보다 먼저 부팅되어 장치 확인, 디스크 준비, 이미지 적용과 진행 상태 보고를 수행합니다.'],
                    bullets: [
                        '대상 아키텍처에 맞는 kernel, initrd와 rootfs를 한 세트로 관리합니다.',
                        '프로비저닝 NIC와 스토리지 장치를 인식할 드라이버가 포함돼야 합니다.',
                        'Subnet에서 사용할 PE를 연결한 뒤 PXE 상태를 확인합니다.',
                    ],
                },
                {
                    title: 'DiskLess Image Linux',
                    bullets: [
                        '공통 rootfs와 노드별 런타임 데이터를 구분합니다.',
                        '부팅 시 rootfs를 가져올 Subnet과 전송 방식을 확인합니다.',
                        '다수 노드 동시 부팅 시 네트워크와 스토리지 부하를 검증합니다.',
                        '이미지 갱신 후 기존 노드의 캐시와 재부팅 정책을 확인합니다.',
                    ],
                },
                {
                    title: 'PE 런타임 보호값',
                    bullets: [
                        'InfiniBand/OPA fabric 준비 시간은 kiera.ib_ready_timeout으로 받으며 기본 30초, 허용 범위 5~600초입니다.',
                        'RootFS 인터페이스 MTU는 kiera.rootfs_mtu로 받으며 기본값은 1450입니다.',
                        'RootFS mount가 진행되지 않으면 900초 stall guard가 무한 대기를 중단합니다.',
                    ],
                    note: '이 값은 PE 커널 파라미터의 현재 런타임 계약입니다. Cluster Deploy 화면의 유사 입력값이 현재 Spring 오케스트레이션에 자동 반영된다고 가정하지 마세요.',
                },
                {
                    title: '검증 기준',
                    steps: [
                        'BIOS와 UEFI 대상에서 PXE 메뉴가 정상 표시됩니다.',
                        'kernel/initrd를 내려받고 사전 설치 환경이 정상 시작됩니다.',
                        'NIC, 디스크와 필수 장치가 인식됩니다.',
                        'KiERA 서버로 상태 보고가 도착합니다.',
                    ],
                },
            ],
        },
        {
            id: 'script-actions',
            category: 'provisioning',
            title: '스크립트 설정과 작업 실행',
            summary: '재사용 가능한 배포 스크립트를 만들고 노드 또는 배포 흐름에서 실행합니다.',
            icon: 'bx bx-code-block',
            audience: '배포 관리자 · 운영자',
            path: '/kiera/scripts',
            tags: ['스크립트', '첨부파일', '작업 실행', '자동화'],
            sections: [
                {
                    title: '스크립트 구성',
                    bullets: [
                        '목적이 드러나는 이름과 설명을 작성합니다.',
                        '대상 노드의 셸과 종료 코드를 확인합니다. 스크립트에서 별도 실행기를 호출하면 해당 실행기를 대상 OS에 준비해야 하며 KiERA가 자동 설치하지 않습니다.',
                        '필요한 첨부파일과 환경 변수를 연결합니다.',
                        '배포 전·후 어느 시점에 실행할지 이미지 또는 클러스터 구성에서 지정합니다.',
                    ],
                },
                {
                    title: '작성 원칙',
                    bullets: [
                        '사용자 입력을 기다리지 않는 비대화형 스크립트로 작성합니다.',
                        '여러 번 실행돼도 결과가 깨지지 않도록 멱등성을 확보합니다.',
                        'timeout, 재시도와 실패 메시지를 명시합니다.',
                        '비밀번호·토큰·개인키를 본문이나 첨부파일에 저장하지 않습니다.',
                    ],
                },
                {
                    title: '작업 실행',
                    steps: [
                        '작업 실행 화면에서 대상 노드 또는 자원 범위를 선택합니다.',
                        '실행할 명령과 권한, 동시 실행 범위를 확인합니다.',
                        '실행 후 결과를 작업 관리와 서비스 로그에서 확인합니다.',
                        '부분 실패가 있으면 성공 대상까지 무조건 재실행하지 말고 실패 범위를 좁힙니다.',
                    ],
                },
                {
                    title: '두 실행 경로 구분',
                    bullets: [
                        'Scripts 화면의 원격 실행은 Node IP·SSH 사용자·비밀번호로 접속하고 화면에 stdout/stderr를 반환합니다.',
                        'Actions 화면의 Script Execute는 현재 agent_task를 만들고 Agent HTTP poll/report로 실행합니다.',
                        'Scripts 원격 실행은 해당 화면의 출력을, Actions 실행은 Jobs의 operation과 agent_task 결과를 확인합니다. 작업 접수 성공을 Script 실행 완료로 판단하지 않습니다.',
                    ],
                },
            ],
        },
        {
            id: 'cluster-deployment',
            category: 'provisioning',
            title: '클러스터 직접 배포',
            summary: '클러스터 또는 배포 그룹 범위로 이미지를 선택하고 직접 배포를 실행합니다.',
            icon: 'bx bx-cloud-upload',
            audience: '배포 관리자',
            path: '/kiera/cluster-deploy',
            tags: ['클러스터 배포', '직접 배포', 'Deployment', 'Nodes'],
            sections: [
                {
                    title: '배포 화면 구성',
                    bullets: [
                        'Overview: 클러스터 구성과 최근 배포·작업 요약',
                        'Deployment: 이미지, 범위와 고급 배포 옵션',
                        'Nodes: 역할, Relay, 상태, Rack과 검색 조건별 노드 목록',
                        'Monitoring: 배포 후 모니터링 상태와 관련 작업',
                        'Logs: 배포·운영 로그의 기간, 유형, 결과와 사용자 필터',
                    ],
                },
                {
                    title: '배포 전 확인',
                    steps: [
                        '클러스터 상태와 대상 노드 선택 범위를 확인합니다.',
                        '직접 배포용 이미지와 아키텍처를 확인합니다.',
                        '직접 배포의 부팅 모드·PXE 유지값과 노드별 스크립트·SSH 키를 확인합니다. SSH/script bootstrap과 Zabbix 후처리 플래그는 Relay 배포 옵션입니다.',
                        '노드 BMC, Subnet, PXE, 대상 디스크와 현재 작업을 확인합니다.',
                    ],
                },
                {
                    title: '배포 실행과 추적',
                    steps: [
                        '클러스터 전체 또는 선택한 배포 그룹을 대상으로 실행합니다.',
                        'Nodes 탭에서 진행·성공·실패·대기 상태를 확인합니다.',
                        'Jobs와 Logs에서 백그라운드 작업과 단계별 오류를 확인합니다.',
                        '완료 후 노드 heartbeat, SSH와 모니터링 상태를 확인합니다.',
                    ],
                    warning: '선택한 이미지와 디스크 설정은 대상 노드의 기존 데이터를 변경할 수 있습니다. 배포 범위를 최종 확인한 뒤 실행하세요.',
                },
                {
                    title: 'Wizard 입력의 현재 제한',
                    bullets: [
                        '중첩 include/exclude 검색 조건은 현재 Spring이 읽는 최상위 node_ids·group_id·rack·status와 다를 수 있습니다.',
                        '템플릿의 노드 자동 등록과 Relay 역할 저장은 지원합니다. 상세 Chassis·slot·VLAN 매핑은 별도 확인이 필요하므로 미리보기와 저장 결과를 대조합니다.',
                        'Relay/Compute RootFS transport와 OPA wait는 작업과 PXE 설정으로 전달됩니다. InfiniBand에는 실제 주소와 관리 Subnet이 필요합니다.',
                    ],
                },
            ],
        },
        {
            id: 'relay-deployment',
            category: 'provisioning',
            title: 'Relay 기반 배포',
            summary: 'Relay 서버를 통해 원격 Subnet의 Compute 노드에 이미지와 설정을 전달합니다.',
            icon: 'bx bx-transfer',
            audience: '배포 관리자',
            path: '/kiera/cluster-deploy',
            tags: ['Relay', 'Compute', '원격 배포', '오케스트레이션'],
            sections: [
                {
                    title: '구성 요소',
                    bullets: [
                        '중앙 KiERA: 배포 계획, 이미지와 상태를 관리합니다.',
                        'Relay: 원격망의 DHCP/PXE, 이미지 전달과 상태 중계를 담당합니다.',
                        'Compute: Relay를 통해 부팅·배포되는 대상 노드입니다.',
                    ],
                },
                {
                    title: '배포 준비',
                    steps: [
                        '클러스터에 Relay와 Compute 역할이 올바르게 지정됐는지 확인합니다.',
                        'Relay Subnet과 노드 연결, 중앙 통신 경로를 확인합니다.',
                        'Relay용 이미지와 Compute용 이미지를 각각 선택합니다.',
                        'Disk-ful/Disk-less 모드와 Ethernet/InfiniBand rootfs 전송 방식을 확인합니다.',
                        'Preflight 결과의 경고를 해결한 뒤 오케스트레이션을 시작합니다.',
                    ],
                },
                {
                    title: '대규모 배포 옵션',
                    bullets: [
                        'Window Size로 DHCP Authority마다 동시에 활성화할 Compute 슬롯 수를 제한합니다.',
                        'Window Gap으로 완료·실패해 빈 슬롯에 다음 Compute를 보충하기 전 간격을 조절합니다.',
                        'boot mode와 persistent PXE 같은 실제 적용되는 옵션을 대상 환경에 맞게 설정합니다.',
                        '오류 상세에서 실패 단계와 대상 노드를 분리해 재시도합니다.',
                    ],
                    warning: 'RootFS 전송 방식과 OPA 대기 시간은 Spring 작업·PXE에 적용됩니다. RootFS MTU의 화면값은 별도 실행 적용 여부를 확인해야 합니다. 실제 fabric 부팅 성공은 장비에서 검증합니다.',
                },
                {
                    title: 'Authority 슬롯과 작업 처리 한도',
                    bullets: [
                        'Spring은 DHCP Authority별로 독립된 sliding window를 만들고, 같은 Authority 안에서는 Member Relay에 배정된 Compute를 먼저 relay round-robin으로 등록한 뒤 Authority Relay 자체 배정 Compute를 처리합니다.',
                        '각 슬롯은 PXE 준비·BMC 전원/부팅 제어 operation이 완료 또는 실패하면 해제되고 Window Gap 뒤 다음 Compute를 보충합니다. OS 설치 완료를 기다리는 슬롯이 아닙니다.',
                        'Java operation worker의 전체 작업 동시 처리 기본값 4건·요청당 1건은 Authority별 Window Size와 다른 계층입니다. 두 값을 합쳐 전체 설치 동시 노드 수로 해석하지 않습니다.',
                        'OS 설치와 상태 보고는 이미 시작된 여러 Node에서 겹쳐 진행될 수 있으며, 최종 성공은 후속 compute-ready·callback·Node 상태에서 별도로 확인합니다.',
                    ],
                    warning: 'Authority window와 Java worker 한도는 부팅 집중을 완화하는 제어값이지만 현장 전력·DHCP·Relay·스토리지 부트 스톰 방지를 자동 보장하지 않습니다.',
                },
                {
                    title: '자동 진행과 동기화 복구',
                    bullets: [
                        '중앙 Relay 오케스트레이션은 기본 5초 간격으로 pending/running 작업을 다음 단계로 진행합니다.',
                        'Relay가 중앙으로 보낼 동기화 이벤트를 해석하지 못하면 해당 파일을 .bad로 격리하고 relay_sync_corrupt 신호를 남긴 뒤 다른 이벤트 처리를 계속합니다.',
                        '중앙 cache snapshot은 전용 토큰과 허용 table 계약을 사용하므로 400·401·503 응답을 구분해 확인합니다.',
                    ],
                },
                {
                    title: '완료 확인',
                    bullets: [
                        'Relay 배포 작업이 종료되고 중앙 상태와 동기화됩니다.',
                        'Compute 노드가 목표 상태와 IP를 보고합니다.',
                        '선택한 SSH·Zabbix agent/proxy 후처리의 결과를 확인합니다. 오케스트레이션 완료 표시는 모든 외부 모니터링 데이터의 지속 수집까지 보장하지 않습니다.',
                    ],
                },
            ],
        },
        {
            id: 'deployment-checklist',
            category: 'provisioning',
            title: '배포 전후 체크리스트',
            summary: '실제 배포 작업에서 누락하기 쉬운 준비, 실행 중 관찰과 완료 조건을 확인합니다.',
            icon: 'bx bx-check-square',
            audience: '배포 관리자 · 운영자',
            path: '/kiera/cluster-deploy',
            tags: ['체크리스트', '사전 점검', '완료 조건'],
            sections: [
                {
                    title: '배포 전',
                    bullets: [
                        '대상 클러스터와 노드 수가 요청 범위와 일치합니다.',
                        '노드 전원·BMC 연결과 PXE 준비 상태를 확인합니다. OS·Agent가 아직 없는 신규 노드의 heartbeat·SSH 부재는 배포 전 실패 조건으로 단정하지 않습니다.',
                        '이미지 아키텍처, 부팅 모드, 디스크와 네트워크 구성이 일치합니다.',
                        '진행 중인 다른 배포·작업이 없습니다.',
                        '복구 이미지, 이전 설정과 중단 기준이 준비됐습니다.',
                    ],
                },
                {
                    title: '배포 중',
                    bullets: [
                        '작업 관리에서 pending 또는 running 상태가 장시간 유지되지 않습니다.',
                        '프로비저닝 Rack View에서 상태가 단계별로 진행됩니다.',
                        '서비스 로그에 반복 오류나 대량 재시도가 없습니다.',
                        'Relay 배포는 중앙과 Relay 양쪽 상태가 함께 갱신됩니다.',
                    ],
                },
                {
                    title: '배포 후',
                    bullets: [
                        '노드의 deployed 상태와 최종 OS의 접속·check-in을 확인합니다. 이미지 적용 완료 후 verify-pending이 남으면 Local Boot와 Agent 확인 단계를 대조합니다.',
                        '최종 IP, Gateway, DNS와 SSH 접속을 확인합니다.',
                        '예상한 디스크, 파일시스템과 장치가 보입니다.',
                        'Zabbix 등 선택한 후처리와 모니터링이 준비됩니다.',
                        '실패·예외 노드와 후속 조치를 작업 기록에 남깁니다.',
                    ],
                },
            ],
        },
        {
            id: 'dashboard-rack',
            category: 'operations',
            title: '대시보드와 운영 Rack View',
            summary: '전체 자원 상태를 빠르게 파악하고 이상 노드의 상세 화면으로 이동합니다.',
            icon: 'bx bx-home-circle',
            audience: '운영자',
            path: '/kiera',
            tags: ['대시보드', 'Rack View', '상태', '메모'],
            sections: [
                {
                    title: '대시보드 확인 항목',
                    bullets: [
                        '전체 노드와 유형별 수량',
                        '정상, 경고, 전원 꺼짐 등 상태 요약',
                        '서버 CPU, 메모리, 디스크와 핵심 자원 사용률',
                        '그룹별 현황과 운영 메모',
                    ],
                },
                {
                    title: 'Rack View 활용',
                    bullets: [
                        '자원 관리 Rack View에서 위치와 자산 배치를 확인합니다.',
                        '프로비저닝 Rack View에서 배포 상태와 작업 진행을 확인합니다.',
                        '운영 Rack View에서 장애·경고·가동 상태를 중심으로 확인합니다.',
                    ],
                },
                {
                    title: '이상 징후 발견 시',
                    steps: [
                        '영향받은 노드 또는 그룹을 선택합니다.',
                        '노드 상세의 heartbeat, BMC와 타임라인을 확인합니다.',
                        '작업 관리와 서비스 로그에서 같은 시각의 이벤트를 확인합니다.',
                        '필요하면 검사 화면의 해당 기능 기본 점검을 실행합니다.',
                    ],
                },
            ],
        },
        {
            id: 'job-management',
            category: 'operations',
            title: '작업 관리',
            summary: '실행 중·완료 작업, 큐와 워커 상태를 확인하고 허용된 작업을 취소합니다.',
            icon: 'bx bx-task',
            audience: '운영자',
            path: '/kiera/jobs',
            tags: ['작업', '큐', 'Java Worker', 'PostgreSQL'],
            sections: [
                {
                    title: '작업 목록',
                    bullets: [
                        'Running 탭에서 pending과 running 작업을 확인합니다.',
                        'Completed 탭에서 completed, failed, cancelled, review-needed 결과를 확인합니다.',
                        'origin, 상태, 기간과 검색어로 작업 범위를 좁힙니다.',
                        'operation_task가 업무 상태의 기준이며 Java worker가 DB 대기를 확인하고 Spring 실행 API를 직접 호출합니다. Redis 표시는 세션·연결 진단이며 작업 결과 저장소가 아닙니다.',
                    ],
                    note: '현재 Spring의 operation_task와 agent_task는 DB 기반이며 Agent는 HTTP poll/report로 작업을 가져갑니다. agent_task의 broker_status=db-only를 RabbitMQ 발행 완료로 해석하지 마세요.',
                },
                {
                    title: '취소',
                    paragraphs: ['cancelable로 표시된 작업만 취소할 수 있으며 remove 권한이 필요합니다. 필터 조건에 맞는 취소 가능 작업을 일괄 취소할 수도 있습니다.'],
                    warning: '작업 취소는 이미 장비에서 실행된 전원 제어, 파일 쓰기 또는 배포 단계를 되돌리지 않습니다. 취소 후 대상 노드와 로그를 확인하세요.',
                },
                {
                    title: '정체 작업 진단',
                    steps: [
                        '작업 origin과 마지막 갱신 시간을 확인합니다.',
                        'operation_task는 PostgreSQL 상태와 kiera-operation-worker의 직접 호출·동시 실행·오류 상태를 함께 확인합니다. agent_task는 Agent의 HTTP poll/report를 확인합니다.',
                        '같은 작업 ID를 서비스 로그와 배포 상세 로그에서 찾습니다.',
                        '외부 장비 응답을 기다리는 작업이면 BMC, SSH 또는 Relay 연결을 확인합니다.',
                    ],
                },
            ],
        },
        {
            id: 'service-logs',
            category: 'operations',
            title: '서비스 로그와 로그 정책',
            summary: '서비스별 상태와 로그를 확인하고 보존·노출 정책을 관리합니다.',
            icon: 'bx bx-list-ul',
            audience: '운영자 · superadmin',
            path: '/kiera/logs',
            tags: ['로그', '서비스', '로그 정책', '보존'],
            sections: [
                {
                    title: '서비스 로그',
                    bullets: [
                        '애플리케이션, 배포, DHCP/PXE, Relay와 외부 연동 서비스를 구분해 확인합니다.',
                        '오류 시각, 대상 노드·클러스터·작업 ID를 기준으로 로그를 좁힙니다.',
                        '먼저 Job/trace ID, 다음으로 Node/Cluster, 마지막으로 시간 범위 순서로 필터를 좁히면 같은 작업의 로그를 빠르게 찾을 수 있습니다.',
                        '서비스 시작·중지는 현재 영향 범위와 의존 서비스를 확인한 뒤 실행합니다.',
                    ],
                    note: '일반 요청과 공개 API는 같은 추적 ID를 사용합니다. 유효한 X-Request-ID가 우선하며 없으면 X-Trace-Id를 호환 입력으로 사용합니다.',
                },
                {
                    title: '로그 정책',
                    bullets: [
                        '완료 작업 기록을 노출할지 결정합니다.',
                        '노드 History와 Timeline 기록을 사용할지 결정합니다.',
                        '보존 기간과 운영 화면에서 확인할 범위를 환경 정책에 맞춥니다.',
                    ],
                    note: "로그 정책은 관리 / 지원에서 superadmin이 관리합니다. BMC 상태 이력과 PXE DB 이력도 보존 대상이며 기본은 무기한입니다. 기간을 설정하면 실행당 최대 5,000건씩 정리하므로 적용 범위를 먼저 확인하세요.",
                },
                {
                    title: '로그 공유',
                    warning: '로그에 비밀번호, 토큰, 세션, 개인키나 내부 시스템 정보가 포함될 수 있습니다. 외부 공유 전 반드시 마스킹하세요.',
                },
                {
                    "title": "수집 정책과 실제 작업 상태",
                    "bullets": [
                        "사용자 변경·API·Assistant 도구 감사는 각 정책에 따라 기록합니다. 작업·이벤트 저널과 노드 Timeline은 해당 수집 설정과 종류·기간 필터를 따릅니다.",
                        "로그 수집을 꺼도 실제 작업 큐·배포 상태·최신 BMC 상태는 유지합니다. 적용 전 누락된 활동 이력은 새로 만들어 채우지 않습니다."
                    ]
                },
            ],
        },
        {
            id: 'inspect',
            category: 'operations',
            title: '검사와 Smoke Test',
            summary: '시스템 전반의 기본 상태와 메뉴별 실제 동작을 점검합니다.',
            icon: 'bx bx-shield-quarter',
            audience: '운영자 · 관리자',
            path: '/kiera/inspect',
            tags: ['검사', '기본 점검', 'Smoke Test', '진단'],
            sections: [
                {
                    title: '일반 검사',
                    bullets: [
                        '전체 점검을 실행해 정상과 경고 항목 수를 확인합니다.',
                        '점검 시각과 섹션별 상세 결과를 확인합니다.',
                        '경고는 관련 메뉴, 로그와 서비스 상태를 함께 대조합니다.',
                    ],
                },
                {
                    title: '메뉴별 검사',
                    bullets: [
                        'Basic 검사는 설정과 읽기 경로처럼 부작용이 적은 기본 상태를 확인합니다.',
                        'Smoke 검사는 입력값을 받아 실제 작업 경로를 확인할 수 있습니다.',
                        '비동기 검사는 job ID로 진행 상태를 주기적으로 갱신합니다.',
                    ],
                    warning: 'Smoke Test는 실제 자원, 네트워크 또는 외부 시스템에 요청을 보낼 수 있습니다. 테스트 대상과 입력값을 확인하세요.',
                },
                {
                    title: '권장 사용 시점',
                    bullets: [
                        '신규 설치 또는 초기 구성 완료 후',
                        '이미지, Relay, 네트워크 또는 외부 연동 변경 후',
                        '배포 장애를 재현하기 전과 복구 후',
                        '정기 점검과 운영 인수인계 시',
                    ],
                },
                {
                    title: '검사 범위와 부작용',
                    bullets: [
                        '일반 검사는 DB, PXE 파일, service, Docker, endpoint, storage, Node health, ready/PXE 정합성과 cache를 확인합니다.',
                        'Sidebar 검사는 주요 route와 선택 API의 기본 응답을 확인합니다.',
                        '생성 Smoke는 임시 Group·Node·Image를 만들고 검증 후 정리합니다.',
                        'Node·Relay E2E Smoke는 Commission, Deploy, Script, Power, Release와 PXE 정리까지 실제 작업을 실행합니다.',
                    ],
                    warning: 'Inspect script callback에는 token·대상 Node binding 보강이 필요한 현재 제한이 있으므로 E2E Smoke는 격리된 테스트 자원에서만 실행하세요.',
                },
            ],
        },
        {
            id: 'terminal-sol',
            category: 'operations',
            title: 'SSH 터미널과 IPMI SOL',
            summary: '노드 상세에서 OS 터미널과 BMC Serial Over LAN을 안전하게 사용합니다.',
            icon: 'bx bx-terminal',
            audience: '운영자',
            path: '/kiera/nodes',
            tags: ['SSH', 'Terminal', 'SOL', '콘솔'],
            sections: [
                {
                    title: 'SSH 터미널',
                    bullets: [
                        '배포된 OS가 네트워크와 SSH 준비 상태인지 확인합니다.',
                        '노드 상세의 실제 IP와 SSH 사용자·인증 방식을 확인합니다.',
                        '브라우저 터미널 연결이 끊기면 노드 heartbeat와 서버 WebSocket 상태를 함께 확인합니다.',
                    ],
                },
                {
                    title: 'IPMI SOL',
                    bullets: [
                        'OS 부팅 전 BIOS, PXE와 커널 로그를 확인할 때 사용합니다.',
                        'BMC Credentials와 SOL 지원 여부를 확인합니다.',
                        '기존 SOL 세션이 남아 있으면 장비 정책에 따라 새 연결이 거부될 수 있습니다.',
                        '서버는 정의된 8개 SOL 상태만 정규화하고 로그 정책이 켜진 경우 노드별 최신 500개 이벤트를 JSONL에 유지합니다.',
                    ],
                },
                {
                    title: '안전한 운영',
                    warning: '터미널과 SOL에서 실행한 명령은 즉시 대상 장비에 적용됩니다. 재부팅, 디스크 변경과 네트워크 수정 전 대상 노드 ID를 다시 확인하세요. 세션 종료 시 서버는 하위 프로세스·TTY marker까지 정리하지만, 장비에서 이미 실행된 명령은 되돌리지 않습니다.',
                },
            ],
        },
        {
            id: 'monitoring-integrations',
            category: 'operations',
            title: 'Zabbix와 외부 연동',
            summary: '노드 모니터링과 Lustre, Juju 등 외부 시스템의 연결 상태를 확인합니다.',
            icon: 'bx bx-bar-chart-alt-2',
            audience: '운영자 · 연동 관리자',
            path: '/kiera/zabbix',
            tags: ['Zabbix', 'Lustre', 'Juju', '모니터링'],
            sections: [
                {
                    title: 'Zabbix',
                    bullets: [
                        '노드 상세에서 agent 설치·연결과 server/proxy 정보를 확인합니다.',
                        '클러스터 배포 옵션에서 배포 후 agent/proxy 구성을 선택할 수 있습니다.',
                        '연결 실패 시 노드 SSH, 방화벽, server/proxy 주소와 host 식별값을 확인합니다.',
                        'Relay/Compute 배포는 OS·codename별 offline bundle로 Agent를 설치하며 masked/empty service를 복구한 뒤 active 상태를 확인합니다.',
                    ],
                },
                {
                    title: 'Lustre와 Juju',
                    bullets: [
                        '연동 계정, endpoint와 대상 자원의 식별자가 현재 환경과 일치하는지 확인합니다.',
                        'KiERA 화면의 상태와 외부 시스템의 실제 상태를 대조합니다.',
                        '인증 만료, API timeout과 권한 오류는 서비스 로그에서 확인합니다.',
                    ],
                    note: 'Lustre local status는 중앙 호스트의 lctl/lfs, kernel module, package와 repository 후보를 검사해 installed/installable/blocked로 판정합니다. 원격 MGS mount 상태와 구분해 확인하세요.',
                },
                {
                    title: '연동 변경 원칙',
                    note: '외부 연동 설정을 바꿀 때는 대표 노드 한 대 또는 테스트 클러스터로 등록·조회·삭제 흐름을 확인한 뒤 범위를 확대하세요.',
                },
            ],
        },
        {
            id: 'discovery-troubleshooting',
            category: 'operations',
            title: 'BMC 검색·전원 제어 문제 해결',
            summary: 'Discovery 결과가 없거나 BMC 명령이 실패할 때 확인할 항목입니다.',
            icon: 'bx bx-error-circle',
            audience: '자원 관리자 · 운영자',
            path: '/kiera/bmc-discovery',
            tags: ['장애', 'BMC', 'Discovery', '전원 제어'],
            sections: [
                {
                    title: '검색 결과가 없을 때',
                    steps: [
                        '입력한 IP 주소 또는 범위와 BMC망 라우팅을 확인합니다.',
                        '선택한 Credential Profile에 Password가 저장돼 있는지 확인합니다.',
                        'IPMI/Redfish 프로토콜과 장비의 HTTPS 접속 상태를 확인합니다. Redfish TLS가 켜져 있으면 신뢰할 수 있는 인증서와 일치하는 호스트 이름이 필요합니다.',
                        '방화벽과 장비의 관리 서비스가 요청을 허용하는지 확인합니다.',
                        '이미 등록된 노드로 제외됐는지 노드 목록에서 주소를 검색합니다.',
                    ],
                },
                {
                    title: '전원·부팅 명령 실패',
                    bullets: [
                        '먼저 Current Power Status 또는 Current Boot Device 조회가 성공하는지 확인합니다.',
                        '장비가 요청한 UEFI/Legacy 부팅 모드를 지원하는지 확인합니다.',
                        '동시에 다른 관리 도구가 BMC 세션을 점유하고 있지 않은지 확인합니다.',
                        'Force Power Off는 마지막 수단으로 사용하고 실행 중 워크로드를 확인합니다.',
                    ],
                },
                {
                    title: '증거 수집',
                    bullets: [
                        '장비 주소, 프로토콜, 실행 시각과 명령 종류',
                        '화면에 표시된 오류 메시지와 서비스 로그의 같은 시각 오류',
                        '같은 Credential Profile을 사용하는 다른 장비의 성공 여부',
                    ],
                },
            ],
        },
        {
            id: 'pxe-deployment-troubleshooting',
            category: 'operations',
            title: 'PXE·배포 문제 해결',
            summary: 'PXE 부팅 실패, 배포 정체와 완료 후 접속 불가 문제를 단계별로 진단합니다.',
            icon: 'bx bx-bug',
            audience: '배포 관리자 · 운영자',
            path: '/kiera/inspect',
            tags: ['장애', 'PXE', '배포 정체', '네트워크'],
            sections: [
                {
                    title: 'PXE 화면이 나오지 않을 때',
                    steps: [
                        '노드의 one-time boot와 UEFI/Legacy 모드가 배포 설정과 일치하는지 확인합니다.',
                        'Subnet의 DHCP 범위, next-server와 PXE 부트로더 생성 상태를 확인합니다.',
                        'DHCP, TFTP/HTTP 서비스와 방화벽 상태를 확인합니다.',
                        '노드 MAC이 올바른 Subnet과 배포 대상에 연결됐는지 확인합니다.',
                    ],
                },
                {
                    title: '배포가 진행되지 않을 때',
                    steps: [
                        '클러스터 배포 Nodes 탭에서 마지막 상태를 확인합니다.',
                        '작업 관리에서 pending/running/failed 작업과 큐 상태를 확인합니다.',
                        '서비스 로그에서 같은 노드, 작업 ID와 시각을 검색합니다.',
                        '이미지 파일, 사전 설치 환경, 대상 디스크와 스크립트 오류를 확인합니다.',
                        'Relay 배포라면 중앙-Relay 동기화와 Relay Subnet을 추가로 확인합니다.',
                    ],
                    note: 'node_pxe_status.status는 DB에서 VARCHAR(16)이므로 긴 단계명이 잘릴 수 있습니다. 정확한 PXE 단계는 Node별 deploy JSONL과 boot log를 기준으로 확인하고, Relay queue의 .bad 파일 또는 relay_sync_corrupt 신호도 함께 찾으세요.',
                },
                {
                    title: '완료 후 접속이 안 될 때',
                    bullets: [
                        'Disk-Ful은 Local Disk 부팅을, Disk-Less는 해당 이미지의 네트워크 RootFS 부팅을 확인합니다.',
                        '최종 NIC 이름, IP, Gateway와 DNS 구성을 확인합니다.',
                        'SSH bootstrap 결과와 포트 접근 정책을 확인합니다.',
                        'heartbeat와 phone-home은 도착했지만 SSH만 실패하는지 구분합니다.',
                    ],
                },
                {
                    title: '재시도 원칙',
                    warning: '원인을 확인하지 않은 전체 재배포는 증거를 덮고 정상 노드까지 영향을 줄 수 있습니다. 실패 단계와 대상만 좁혀 재시도하세요.',
                },
            ],
        },
        {
            id: 'management-settings',
            category: 'admin',
            title: '관리 설정과 디버그',
            summary: '운영 환경값을 관리하고 필요한 범위에서 디버그 정보를 확인합니다.',
            icon: 'bx bx-cog',
            audience: 'superadmin',
            path: '/kiera/management-settings',
            tags: ['관리 설정', '디버그', '환경 설정'],
            sections: [
                {
                    title: '관리 설정',
                    bullets: [
                        '현재 환경의 서비스 주소, 네트워크와 기능 설정을 검토합니다.',
                        '변경 값의 적용 범위와 재로딩 여부를 화면 안내에서 확인합니다.',
                        '설정 변경 전 현재 값을 기록하고 되돌릴 수 있는 값을 준비합니다.',
                    ],
                },
                {
                    title: '디버그 설정',
                    bullets: [
                        "현재 Debug는 commissioning·deploying 자동 실행 중지, no_shutdown 종료 억제, bypass_ipmi 재시작 우회와 DHCP·NFS·Squid 연동의 7개 설정을 제공합니다.",
                        "현재 코드와 Rome 보완판은 설정을 실행 경로에 적용합니다. commissioning·deploying은 다음 PE 부팅의 자동 스크립트 실행을 멈추며, bypass_ipmi는 전원 on이 확인된 노드의 재시작을 생략합니다.",
                        '수집되는 로그에 인증정보와 개인정보가 포함되지 않도록 하고, 조사 후 임시 로그 정책을 복구합니다.',
                    ],
                    warning: "사용 중인 서버의 runtime_supported와 설정별 지원 안내를 먼저 확인하세요. 진단 후 원래 값을 복원하고 다음 작업과 노드별 설정 적용 범위를 확인하세요. 모든 NFS 환경의 실제 재적용이 검증된 것은 아닙니다.",
                },
                {
                    title: '권한',
                    note: '관리 설정과 일부 로그 정책은 superadmin 전용입니다. 운영자에게 필요한 최소 권한만 부여하세요.',
                },
            ],
        },
        {
            id: 'users-permissions',
            category: 'admin',
            title: '사용자와 메뉴 권한',
            summary: '사용자 역할과 기능별 권한을 분리해 필요한 화면과 작업만 허용합니다.',
            icon: 'bx bx-user-circle',
            audience: 'superadmin',
            path: '/members',
            tags: ['사용자', '역할', '권한', '메뉴 정책'],
            sections: [
                {
                    title: '권한 종류',
                    bullets: [
                        'read: 메뉴와 데이터 조회',
                        'create: 새 자원 또는 설정 생성',
                        'update: 기존 항목과 설정 변경',
                        'remove: 자원·작업 삭제 또는 취소',
                        'execute: 전원, 스캔, 배포와 점검 같은 실행 작업',
                    ],
                },
                {
                    title: '권한 설계',
                    bullets: [
                        '조회 담당자, 자원 관리자, 배포 관리자와 superadmin 역할을 구분합니다.',
                        '전원 제어와 배포 실행 권한은 업무상 필요한 사용자에게만 부여합니다.',
                        '사용하지 않는 계정과 장기 미접속 계정을 정기적으로 검토합니다.',
                    ],
                },
                {
                    title: '변경 검증',
                    steps: [
                        '테스트 계정으로 로그인해 메뉴 노출을 확인합니다.',
                        '목록 조회, 생성, 수정, 삭제와 실행 버튼을 각각 확인합니다.',
                        '권한이 없는 직접 URL과 API 요청이 거부되는지 확인합니다.',
                    ],
                },
                {
                    title: '정책과 감사의 현재 경계',
                    bullets: [
                        'Sidebar 정책은 역할과 다섯 action으로 정규화하고 read가 false면 다른 action도 false로 보정합니다.',
                        "페이지 직접 URL·화면 내부 이동·API가 같은 정책 매핑으로 접근을 검사합니다. 정책이 거부된 페이지는 HTTP 403으로 차단되며, 새 요청에서 저장된 최신 역할 정책을 다시 확인합니다.",
                        'Activity Audit은 민감한 항목을 가리지만 공유 파일 동시 기록의 process 간 내구성은 별도 보강이 필요합니다.',
                        "새 SSH·SOL 연결도 최신 노드 읽기 권한을 확인합니다. 이미 열린 콘솔을 정책 변경 즉시 강제 종료하지는 않습니다. Cloud-init·Relay·Inspect callback은 별도 인증 계약을 따릅니다.",
                    ],
                },
            ],
        },
        {
            id: 'public-api',
            category: 'admin',
            title: 'Swagger와 공개 API',
            summary: '공개 API 문서를 확인하고 자동화 또는 외부 시스템 연동 요청을 검증합니다.',
            icon: 'bx bx-link-alt',
            audience: '관리자 · 개발자',
            path: '/kiera/swagger',
            tags: ['Swagger', 'API', '자동화', '연동'],
            sections: [
                {
                    title: 'API 문서 사용',
                    steps: [
                        '현재 /api/v1/openapi.json은 기존 32개와 추가 7개를 합친 39개 operation의 요청·응답·인증 명세를 제공합니다.',
                        '명세 제공과 실장비 검증은 별개입니다. 자동화 전 실제 Controller, 역할·scope, 오류 응답과 경계 입력을 확인합니다.',
                        'Swagger의 Try it out으로 요청 형식과 응답을 확인합니다. 전원·배포 등 변경 요청은 지정한 시험 대상에만 실행합니다.',
                        '테스트 환경의 인증정보와 최소 권한 계정을 사용합니다.',
                        '필수 필드, 식별자와 오류 응답을 먼저 검증합니다.',
                        '대량 요청은 페이지네이션, 중복 처리와 rate 영향 범위를 확인합니다.',
                    ],
                    note: '일반 HTTP X-Request-ID, 공개 API X-Trace-Id와 응답 trace_id는 같은 값으로 연결됩니다. 자동화 로그에 이 추적 ID를 보존하세요.',
                },
                {
                    title: '노드 등록 자동화',
                    bullets: [
                        '외부 자산 정보와 KiERA의 고유 식별자를 일관되게 매핑합니다.',
                        'BMC 주소, MAC과 노드 이름 중복을 요청 전에 확인합니다.',
                        '등록 결과를 노드 목록과 API 응답 양쪽에서 확인합니다.',
                    ],
                },
                {
                    title: '보안',
                    warning: 'API 키, 세션 쿠키와 요청 전문을 문서·채팅·공용 로그에 남기지 마세요. 운영 API에 테스트 데이터를 보내기 전 대상 프로젝트를 확인하세요.',
                },
                {
                    title: '응답 확인',
                    note: '공개 API의 HTTP 상태와 응답 오류를 함께 확인합니다. 화면용 /wiz/api 요청은 HTTP 200이어도 본문의 code가 오류일 수 있으므로 자동화에서 두 값을 구분하세요.',
                },
            ],
        },
        {
            id: 'development-build-test',
            category: 'admin',
            title: '개발, 빌드와 테스트',
            summary: 'Spring·Java 중심의 현재 실행 구조에서 WIZ KiERA 기능을 수정하고 검증하는 흐름입니다.',
            icon: 'bx bx-code-alt',
            audience: '개발자',
            tags: ['개발환경', 'WIZ', '빌드', '테스트'],
            sections: [
                {
                    title: '프로젝트 구조',
                    bullets: [
                        'src/app: Page, Layout과 Component 화면',
                        'spring: 현재 UI API, 공개 API, PXE/cloud-init, WebSocket과 도메인 Service/Repository를 소유하는 Spring Boot 백엔드',
                        'relay-spring: Relay API·cache·sync를 처리하는 Spring Boot 런타임',
                        'infra/kiera-operation-worker: PostgreSQL 작업을 확인하고 동시 실행 수를 제한해 Spring operation_run을 직접 호출하는 Java worker',
                        'infra/kiera-system-agent: localhost token으로 중앙 호스트 권한 작업을 격리하는 Spring Boot Java runtime',
                        'spring/src/main/java: 인증·업무·공개 API·PXE·실시간 통신의 서버 구현',
                        'config, spring/src/main/resources, infra: 설정·환경변수·서비스 배포 구성',
                        'spring/src/test·relay-spring/src/test와 각 infra 모듈의 src/test: Java 시험. tests/*.cjs: 화면·번역 계약 검사',
                    ],
                },
                {
                    title: '현재 실행 경계',
                    bullets: [
                        'Spring primary·secondary가 UI·공개 API·PXE/cloud-init·WebSocket과 Agent poll/report 요청을 처리합니다.',
                        'Operation 작업은 PostgreSQL operation_task에 저장되고 Java worker가 Spring 실행 API를 직접 호출합니다. 선점·재시도·결과는 DB가 관리하며 RabbitMQ는 필요하지 않습니다.',
                        'Node의 agent_task는 Spring API가 제공한 raw script를 POSIX 셸 Agent가 HTTP poll/report로 실행합니다. Agent 자체에 추가 언어 런타임 없이 실행합니다.',
                        '중앙·Relay·Worker·System Agent·CLI와 설치·복원·배포 검사 도구는 Java로 실행합니다. Node Agent는 POSIX 셸이고 화면 빌드는 Node.js를 사용합니다.',
                        '문서·과거 코드에만 있는 기능은 Spring Controller→Service→저장소 또는 실제 호출 경로가 연결되는지 확인한 뒤 현재 기능으로 판단합니다.',
                    ],
                },
                {
                    title: '개발 순서',
                    steps: [
                        '관련 화면과 Spring Controller, Service/Struct, Repository와 DB schema를 확인합니다.',
                        '데이터와 권한 경계를 먼저 정한 뒤 UI를 연결합니다.',
                        '변경과 직접 관련된 계약 테스트를 실행합니다.',
                        'WIZ 일반 빌드와 관련 Spring·Java·Relay Maven 시험으로 UI·API 구성을 확인합니다.',
                        '대상 화면의 정상·빈 값·오류·권한 상태를 확인합니다.',
                    ],
                },
                {
                    title: '빌드 선택',
                    bullets: [
                        '기존 UI 또는 함수 내용 변경은 일반 빌드를 사용합니다.',
                        'API 함수 추가·삭제·이름 변경은 클린 빌드를 사용합니다.',
                        'socket 변경은 클린 빌드와 별도 반영 절차가 필요합니다.',
                        'Angular 21 UI의 실제 릴리스 게이트는 WIZ 빌드입니다. 별도 표준 Angular CLI 빌드의 기존 생성 코드 strict 진단을 WIZ 빌드 실패와 같은 의미로 해석하지 않습니다.',
                        'Java operation worker나 System Agent 변경은 해당 infra 모듈의 Maven 시험과 Compose config를 함께 확인합니다.',
                        'build와 bundle 산출물은 직접 수정하지 않습니다.',
                    ],
                },
                {
                    title: 'Spring 런타임 배포',
                    bullets: [
                        '완성된 Spring Boot JAR은 런타임 이미지의 /app/application.jar에 복사하며 실행 컨테이너에 host target JAR을 bind mount하지 않습니다.',
                        'Maven package 뒤 런타임 이미지를 다시 만들고 secondary로 들어오는 새 요청을 차단하고 진행 중 요청을 마친 뒤 교체·검증하고, 이후 primary를 같은 순서로 교체합니다.',
                        'readiness와 실제 인증 조회, 이미지/JAR 해시, 브라우저형 Accept-Language 요청을 함께 확인합니다. 단순 liveness나 curl 200만으로 화면 렌더링을 완료로 판단하지 않습니다.',
                    ],
                    warning: '실행 중인 JAR 경로를 직접 덮어쓰면 컨테이너가 중간 JAR inode를 계속 참조해 일부 클래스가 늦게 500으로 실패할 수 있습니다.',
                },
                {
                    title: '테스트 예시',
                    code: [
                        'mvn -f spring/pom.xml test',
                        'mvn -f infra/kiera-operation-worker/pom.xml test',
                        'mvn -f infra/kiera-system-agent/pom.xml test',
                        'mvn -f relay-spring/pom.xml test',
                    ].join('\n'),
                    note: '서버·설치 도구 변경은 관련 Java 시험을 실행하고, 화면 변경은 Node.js 웹 빌드와 해당 화면 검사를 수행합니다.',
                },
            ],
        },
        {
            id: 'actions-backup-release',
            category: 'provisioning',
            title: 'Actions, Backup과 Release',
            summary: '노드 대상 작업, 백업과 Release를 실행하고 실제 상태 변화와 취소 경계를 확인합니다.',
            icon: 'bx bx-play-circle',
            audience: '운영자 · 배포 관리자',
            path: '/kiera/actions',
            tags: ['Actions', 'Safe Backup', 'Live Backup', 'Release', 'Commission'],
            sections: [
                {
                    title: '실행 전 준비',
                    steps: [
                        'Group, Rack 또는 개별 Node로 대상을 좁히고 실제 선택 건수를 확인합니다.',
                        'Deploy에는 대상 Image·PXE·Cloud-init 준비가 필요합니다. Commission은 PE와 PXE를 사용하며 배포용 OS Image 선택이 항상 필수인 것은 아닙니다. BMC가 없으면 PXE 준비 후 수동 부팅이 필요한 결과를 확인합니다.',
                        'Script Execute는 노드 Agent가 online이고 실행할 Script가 등록돼 있어야 합니다.',
                        '화면의 실행 확인 대화상자에서 action과 대상 수를 다시 확인합니다.',
                    ],
                },
                {
                    title: '작업별 의미',
                    bullets: [
                        'Commission은 하드웨어·네트워크 정보를 수집하고 정상 완료 시 Node를 ready로 만듭니다.',
                        'Deploy는 필요 시 Commission을 거쳐 Image를 적용하고 성공 시 deployed 상태를 확인합니다.',
                        '현재 Safe Backup과 Live Backup은 모두 PXE backup 경로를 사용합니다. Safe는 off→on, Live는 전원 상태에 따라 on 또는 cycle을 요청하므로 Live를 실행 중 OS의 무중단 백업으로 해석하지 않습니다.',
                        'Release는 PXE 별칭과 배포 연결 상태를 정리하고 Node를 ready로 바꾸며, DB Node row 삭제나 디스크 초기화·OS 정상 동작 보장이 아닙니다.',
                        'Script Execute는 현재 Spring에서 agent_task를 만들고 Agent HTTP poll/report로 실행됩니다.',
                    ],
                },
                {
                    title: '결과와 취소',
                    bullets: [
                        'Actions 결과 요약과 Jobs의 operation 상태, Node의 최종 상태를 함께 확인합니다.',
                        '화면의 정적 안내표보다 Spring 작업 결과와 callback으로 기록된 실제 상태를 우선합니다.',
                        '일반 Job 취소는 cancelled 상태를 기록하고 다음 Node 실행과 대기 Agent 작업을 막습니다. 이미 시작된 BMC·SSH·Relay·Agent 작업의 강제 중단·원복은 보장하지 않습니다.',
                    ],
                    warning: '부분 실패 시 전체 대상을 다시 실행하지 말고 실패 Node, 마지막 성공 단계와 외부 작업 진행 여부를 먼저 확인하세요.',
                },
            ],
        },
        {
            id: 'ssh-key-management',
            category: 'provisioning',
            title: 'SSH Key Management',
            summary: 'SSH Key Pair의 생성·조회·삭제와 배포 사용 범위, 현재 구현 제한을 설명합니다.',
            icon: 'bx bx-key',
            audience: '관리자 · 배포 관리자',
            path: '/kiera/keys',
            tags: ['SSH Key', 'Key Pair', 'Private Key', 'Cluster Key'],
            sections: [
                {
                    title: '지원 동작',
                    bullets: [
                        '이름과 필요 시 Key의 passphrase를 입력해 새 Key Pair를 생성합니다. 이 값은 노드 SSH 로그인 비밀번호와 다릅니다.',
                        '목록 검색과 정렬로 Key를 찾고 공개키·개인키 값을 열람(Reveal)합니다.',
                        'Reveal은 key_management의 update 권한으로 검사합니다. 감사 기록은 user_activity 정책이 켜진 경우 남으며, 확인이 끝나면 다시 숨깁니다.',
                        '삭제 전 Cluster, Image, Bootstrap과 Terminal에서 사용 중인지 확인합니다.',
                    ],
                },
                {
                    title: '현재 제한',
                    warning: 'Upload Key Pair는 64 KiB 이하의 SSH 개인키를 검증해 가져옵니다. 공개키 파일은 선택 사항이며, 제공하면 개인키에서 유도한 값과 일치해야 합니다. 암호가 있는 개인키에는 passphrase가 필요합니다.',
                    bullets: [
                        'copy_head_ssh_keys는 호환 API 이름입니다. 응답의 key_source=cluster처럼 Cluster 공용 키를 배포하며 Head Node의 개인키를 읽지 않습니다.',
                        'Cluster 개인키는 DB JSON에서 암호화하고 SSH용 파일은 0600 권한으로 저장합니다. 복구 시 Field Encryption key도 보존해야 합니다.',
                    ],
                },
                {
                    title: '안전한 사용',
                    bullets: [
                        'Private Key 값은 문서·채팅·스크린샷·서비스 로그에 남기지 않습니다.',
                        '공용 관리자 Key보다 목적별·환경별 Key를 사용하고 정기적으로 교체합니다.',
                        'Key 변경 후에는 대표 Node에서 SSH와 배포 bootstrap을 확인합니다.',
                    ],
                },
            ],
        },
        {
            id: 'commissioning-agent',
            category: 'provisioning',
            title: 'Commissioning, Phone-home과 Agent',
            summary: 'Node 준비 상태를 만드는 Commissioning과 Agent 작업·상태 보고 경계를 설명합니다.',
            icon: 'bx bx-chip',
            audience: '배포 관리자 · 운영자',
            path: '/kiera/actions',
            tags: ['Commissioning', 'Phone-home', 'Heartbeat', 'Agent', 'Cloud-init'],
            sections: [
                {
                    title: '정보 수집과 독립된 보고 채널',
                    steps: [
                        'Commission 또는 Commission 후 Deploy 작업이 commissioning 상태와 PXE·Cloud-init 정보를 준비합니다. 모든 Deploy가 반드시 Commission을 거치는 것은 아닙니다.',
                        'PE 또는 사전 설치 OS가 하드웨어·네트워크 정보를 수집해 상태를 보고합니다.',
                        'Agent 작업은 별도 채널입니다. 실행할 agent_task가 있을 때 HTTP poll로 가져가고 report로 결과를 반환하며 Commission 완료의 필수 단계는 아닙니다.',
                        'Commission 완료 phone-home은 ready 또는 이어지는 deploying 상태를 반영합니다. Disk-Ful은 이미지 적용 뒤 verify-pending·Local Boot·Agent check-in을, Disk-Less는 이미지 ID가 확인된 완료 callback을 대조합니다.',
                    ],
                },
                {
                    title: '현재 실행 경계',
                    bullets: [
                        '설치형 Node Agent는 Spring이 생성·배포하는 POSIX 셸입니다. curl로 raw script를 poll하고 X-Kiera-Task-Id를 읽어 실행 결과를 report하며 Agent 자체는 raw script와 HTTP 헤더를 사용합니다.',
                        '현재 Spring 구현의 agent_task는 broker_status=db-only이며 RabbitMQ publish 완료를 뜻하지 않습니다.',
                        'task의 ttl_seconds는 저장되지만 pending claim 시 만료 여부를 검사하지 않습니다.',
                        'cloud-init Agent poll/report, heartbeat와 Relay status callback은 별도 application 자격증명 없이 허용되는 경로가 있어 현장망 ACL이 중요합니다.',
                        'Spring Agent 유지관리는 기본 비활성입니다. 관리자가 지정한 노드에서 Zabbix 설치·설정과 Disk-Less 런타임 메타데이터를 점검·보완하며 진행 중 작업과 최근 성공을 중복 실행하지 않습니다.',
                    ],
                },
                {
                    title: '실패 확인 순서',
                    steps: [
                        'Jobs에서 operation과 agent_task 상태를 확인합니다.',
                        'Node Timeline과 PXE boot log에서 마지막 상태를 확인합니다.',
                        '긴 PXE 상태는 DB 16자 제한으로 잘릴 수 있으므로 Node deploy JSONL 원문을 대조합니다.',
                        'Agent의 최근 check-in, 대상 Node ID와 report 결과를 확인합니다.',
                    ],
                },
            ],
        },
        {
            id: 'node-status-lifecycle',
            category: 'resources',
            title: '노드 상태 보드와 상태 변화',
            summary: 'Node 상태 보드의 필터·상태값과 등록부터 Release·삭제까지의 상태 변화를 설명합니다.',
            icon: 'bx bx-pulse',
            audience: '전체 사용자 · 운영자',
            path: '/kiera/status',
            tags: ['Node Status', '상태값', '수명주기', 'Release', '삭제'],
            sections: [
                {
                    title: '상태값 읽기',
                    bullets: [
                        'new는 등록 직후, commissioning은 정보 수집 중입니다. ready는 Commission 완료 또는 Release 뒤에도 표시되며 BMC·이미지·네트워크 준비가 모두 검증됐다는 뜻은 아닙니다.',
                        'deploying은 배포 진행 중입니다. Disk-Ful 이미지 적용 뒤 deploy_status=verify-pending과 Local Boot·Agent 확인을 거쳐 deployed가 됩니다. failed/error는 실패 상태로 Jobs와 로그를 대조합니다.',
                        'on/off는 BMC 전원 관측값이며 프로비저닝 상태와 같은 축으로 해석하지 않습니다.',
                        'Status 화면은 상태·Group·BMC Type(IPMI/Redfish/MQTT) 필터를 함께 적용합니다.',
                    ],
                },
                {
                    title: '상태 확인 자료',
                    bullets: [
                        'DB Node·Deploy 상태, BMC 전원, Agent heartbeat, guest/phone-home, Zabbix와 PXE 로그는 서로 다른 시각에 갱신됩니다.',
                        '화면 상태가 이상하면 Jobs, Node Timeline, BMC 상태 재조회과 서비스 로그를 같은 Node ID·시각으로 대조합니다.',
                        '현재 live snapshot의 mismatch warning은 고정 빈 값이므로 화면 표시만으로 채널 불일치를 자동 판정할 수 없습니다.',
                    ],
                },
                {
                    title: 'Release와 삭제',
                    bullets: [
                        'Release는 PXE 별칭을 삭제하고 status=ready, deploy_status=none으로 바꾸며 Image 연결을 해제합니다. OS 삭제나 디스크 초기화 작업은 아닙니다.',
                        'Node 삭제 전에는 credential 본문을 제거한 inventory와 network/storage/device snapshot을 deleted_node에 보관합니다.',
                        'Node 삭제 시 inventory snapshot을 남기고 관련 관계를 정리합니다. 이 archive는 조회용 기록이며 원래 Node·OS·외부 장비를 자동 복원하는 기능은 아닙니다.',
                    ],
                    warning: 'Release와 Node 삭제의 대상·결과를 구분하세요. 삭제 시 남는 archive는 독립적인 실행 상태나 자동 복구 단계가 아닙니다.',
                },
                {
                    title: '완료와 복구 판단',
                    bullets: [
                        'Disk-Less는 목표 Image가 확인된 완료 callback으로 deployed가 될 수 있어 Disk-Ful의 Local Disk 확인 절차를 그대로 적용하지 않습니다.',
                        'DB 상태, 작업 완료 표시와 실제 OS 접속은 각각 확인합니다. ready·deployed 한 값만으로 모든 장치와 모니터링이 정상이라고 판단하지 않습니다.',
                    ],
                },
            ],
        },
        {
    "id": "runtime-health",
    "category": "operations",
    "title": "Central Runtime과 서비스 상태",
    "summary": "중앙 KiERA의 Edge, Spring, DB 큐, Java Operation Worker·System Agent와 POSIX Node Agent 경계를 확인합니다.",
    "icon": "bx bx-health",
    "audience": "운영자 · 관리자",
    "path": "/kiera/inspect",
    "tags": [
        "Runtime",
        "Healthcheck",
        "Spring",
        "Redis",
        "Java Worker"
    ],
    "sections": [
        {
            "title": "현재 실행 구조",
            "bullets": [
                "Nginx Edge가 TLS 종료, 정적 UI, API와 WebSocket 진입점을 제공합니다.",
                "저장소의 Edge 구성은 Spring primary·secondary에 sticky 분산과 failover를 설정합니다. 실제 두 인스턴스 가동과 장애 시 전환은 현장 환경에서 확인합니다.",
                "Spring primary·secondary는 현재 UI API, Public API, PXE/Cloud-init, callback과 WebSocket 요청을 처리합니다.",
                "PostgreSQL·Redis, Java Operation Worker와 Java System Agent는 각각 독립 컨테이너입니다. 작업 실행은 DB 큐와 직접 호출을 사용합니다. Node Agent는 POSIX 셸 서비스입니다.",
                "RabbitMQ 제거는 새 코드·Compose의 실행 계약입니다. 서버의 실제 전환 여부는 실행 이미지와 worker transport=db-poll로 확인하고, 이전 broker 실패 데이터는 자동 삭제·재실행하지 않습니다."
            ]
        },
        {
            "title": "접속 경로와 포트",
            "bullets": [
                "일반 외부 사용자는 공개 443 HTTPS로 접속하고 내부 Edge의 3001 HTTPS 관리 UI로 전달됩니다.",
                "3000은 Relay·PXE·Cloud-init 등 프로비저닝용 HTTP 경로이며 관리 UI의 일반 외부 진입점이 아닙니다. 접근 허용 범위도 별도로 제한됩니다.",
                "3099는 호스트 내부 검증용 ingress이며 Spring primary 3100과 secondary 3101의 health·조회 경로를 점검할 때 사용합니다.",
                "3001에 평문 HTTP를 보내거나 외부에서 3000·3001 포트로 직접 접속하지 말고 공개 HTTPS URL과 프로토콜을 확인합니다."
            ]
        },
        {
            "title": "점검 순서",
            "steps": [
                "Edge 응답과 Spring readiness/liveness를 확인합니다.",
                "PostgreSQL·Redis를 확인하고 operation 작업이면 kiera-operation-worker의 DB 조회와 Spring 직접 호출을 점검합니다. agent_task는 Agent HTTP poll/report를 사용합니다.",
                "Java Operation Worker·System Agent와 대상 Node의 POSIX Agent가 필요한 작업 유형에서 응답하는지 확인합니다.",
                "Inspect, Jobs와 Service Logs에서 같은 시각의 오류를 연결합니다."
            ]
        },
        {
            "title": "정상과 이상 상태",
            "bullets": [
                "정상은 UI 응답뿐 아니라 Spring health, 저장소 연결과 필요한 worker/agent 경계가 함께 준비된 상태입니다.",
                "한 Spring 인스턴스 실패 시 다른 인스턴스로 요청이 이동하는지 확인합니다.",
                "운영 요청은 Spring이 처리하고 CLI·설치·암호화 이관·복원·순차 배포 도구는 Java 25를 사용합니다. Node Agent는 POSIX 셸입니다.",
                "서버 구현은 spring/, relay-spring/, infra/의 Java 모듈을 확인합니다. 화면은 src/app·src/angular·src/portal의 TypeScript·Pug를 사용합니다."
            ]
        },
        {
            "title": "Health와 순차 배포",
            "bullets": [
                "liveness는 JVM 프로세스가 살아 있는지, readiness는 PostgreSQL·Redis 등 요청 처리 준비가 됐는지를 구분합니다. UI 200, readiness, 업무 조회를 함께 확인합니다.",
                "순차 배포는 교체할 upstream을 새 요청 대상에서 먼저 제외하고 활성 작업을 기다린 뒤 secondary→primary 순서로 교체합니다.",
                "Spring JAR은 이미지에 내장하므로 host target JAR 변경만으로 실행 컨테이너가 갱신되지 않습니다. 새 이미지와 컨테이너 재생성이 필요합니다.",
                "두 Spring과 주요 저장소가 같은 호스트에 있으면 인스턴스 장애 전환은 가능해도 호스트·디스크·네트워크 전체 HA를 뜻하지 않습니다."
            ]
        },
        {
            "title": "연결 끊김과 오프라인 화면",
            "bullets": [
                "HTTPS 등 보안 컨텍스트에서는 브라우저가 오프라인 안내 화면을 등록할 수 있습니다. 서버 연결 불가 안내가 뜨면 네트워크·VPN·공개 주소를 확인한 뒤 다시 시도하거나 새로고침합니다.",
                "PWA의 오프라인 안내는 인증된 화면·API·장비 명령을 저장하거나 오프라인으로 실행하는 기능이 아닙니다. 연결이 끊긴 동안 새 제어 명령이 실행됐다고 판단하지 않습니다.",
                "기존 요청은 서버에서 계속될 수 있으므로 연결 복구 후 Jobs와 대상 상태를 먼저 확인합니다. 초기 빈 화면·세션 만료·오프라인 안내를 구분해 접속 시각과 오류를 기록합니다."
            ]
        }
    ]
},
        {
            id: 'assistant-rag-tools',
            category: 'admin',
            title: 'AI Assistant와 검색·도구 사용 범위',
            summary: 'Assistant 설정, RAG 문서와 읽기·변경 Tool의 확인·감사 경계를 설명합니다.',
            icon: 'bx bx-bot',
            audience: '관리자 · 개발자',
            path: '/kiera/assistant',
            tags: ['AI Assistant', 'RAG', 'Tool', 'Allowed Root', 'Confirm'],
            sections: [
                {
                    title: '설정과 RAG',
                    bullets: [
                        'Assistant endpoint와 model을 설정하고 runtime API Key를 입력합니다. Key는 서버 설정 파일에 저장되지 않으므로 저장 버튼이 영구 보관을 뜻하지 않습니다.',
                        '허용 디렉터리는 Assistant가 파일을 확인할 수 있는 경계를 제한합니다.',
                        'RAG 문서를 업로드·수정·활성/비활성·삭제하고 builtin 문서는 복원할 수 있습니다.',
                        '운영 정보가 포함된 문서는 소유자, 최신성, 민감정보와 활성 상태를 정기적으로 확인합니다.',
                    ],
                },
                {
                    title: 'Tool 실행 경계',
                    bullets: [
                        '허용된 역할의 읽기 Tool은 확인 절차 없이 실행할 수 있습니다. 서버 파일·DB Tool은 superadmin, KiERA Action Tool은 operator 이상으로 제한되며 변경 작업은 명시적 confirm을 기다립니다.',
                        'release, deploy, commission은 전용 Actions 경로를 사용하며 임의 DB 상태 수정으로 대체하지 않습니다.',
                        'cancel을 선택하거나 확인 대기가 만료되면 변경 작업을 실행하지 않습니다.',
                        'Tool action 결과와 오류는 audit 기록에서 대상·actor·시각을 확인합니다.',
                    ],
                },
                {
                    title: '보안 주의',
                    warning: 'API Key, 비밀번호, private key와 운영 로그 전문을 질문이나 RAG 문서에 넣지 마세요. 허용 디렉터리는 필요한 디렉터리만 최소 범위로 등록하세요.',
                },
            ],
        },
        {
    "id": "automation-schedulers",
    "category": "operations",
    "title": "자동 실행·스케줄러와 유지관리",
    "summary": "주기적으로 작업을 실행하는 처리기(runner), 로그 정리, BMC 점검과 Relay 진행 조건을 설명합니다.",
    "icon": "bx bx-time-five",
    "audience": "운영자 · 관리자",
    "path": "/kiera/jobs",
    "tags": [
        "Scheduler",
        "자동화",
        "BMC Window",
        "Log Retention",
        "Relay Progression"
    ],
    "sections": [
        {
            "title": "자동 실행 항목",
            "bullets": [
                "Operation runner는 주기적으로 작업을 처리한 뒤 보존 기간이 지난 로그를 정리하고, 실행할 때가 된 BMC 점검을 예약합니다.",
                "특정 task ID를 수동 실행하면 이 자동 유지관리 결합 동작을 건너뜁니다.",
                "Relay 오케스트레이션 scheduler는 기본 5초 간격으로 pending/running job을 다음 단계로 진행합니다.",
                "워커는 DB의 pending/stale 존재 여부를 확인하고 빈 큐에서도 주기를 제한한 maintenance 호출을 유지합니다. 선점·재시도·취소·결과는 Spring과 PostgreSQL이 관리합니다."
            ]
        },
        {
            "title": "동시성과 보존",
            "bullets": [
                "BMC window_size는 한 번에 묶어 실행하는 수가 아니라 아직 완료되지 않은 작업의 최대 수를 제한합니다.",
                "Java operation worker는 기본 동시 요청 4개·요청당 작업 1건으로 인증된 Spring API를 직접 호출합니다. 성공한 batch 뒤에는 다음 batch를 이어 처리하며 AMQP prefetch·ACK는 사용하지 않습니다.",
                "Relay Compute Window는 DHCP Authority별 별도 한도이며 PXE/BMC operation 완료·실패에서 슬롯을 보충합니다. Java worker의 4건과 같은 설정이 아닙니다.",
                "Log Policy는 BMC 상태 이력과 PXE DB 부팅 이력도 정리합니다. 기본 보존값은 무기한이며, 기간을 설정하면 실행당 각 최대 5,000행씩 정리합니다.",
                "하나의 Relay job 오류는 다른 job 진행을 막지 않으며 개별 job 오류를 별도로 기록합니다."
            ]
        },
        {
            "title": "운영 확인",
            "steps": [
                "Jobs에서 예정·실행·실패 상태와 마지막 갱신 시각을 확인합니다.",
                "BMC monitoring의 주기·window·timeout과 Relay scheduler 설정을 각각 확인합니다. 결합 runner는 로그 정리와 BMC 점검 시점 확인을 모두 호출하지만 실제 실행 여부는 각 실행 주기·조건에 따라 달라집니다.",
                "Log Policy preview와 DB 증가량을 대조합니다.",
                "수동 재실행 전 동일 scheduler가 이미 처리 중인지 확인합니다."
            ]
        }
    ]
},
        {
            id: 'relay-sync-recovery',
            category: 'operations',
            title: 'Relay 동기화·Callback과 복구',
            summary: 'Relay queue, Compute callback과 손상·stale event를 안전하게 분리해 복구합니다.',
            icon: 'bx bx-sync',
            audience: '배포 관리자 · 운영자',
            path: '/kiera/relay',
            tags: ['Relay Sync', 'Callback', 'ACK', 'Retry', 'Poison Event'],
            sections: [
                {
                    title: '동기화 흐름',
                    steps: [
                        'Central이 Relay job과 자산·설정 snapshot을 준비합니다.',
                        'Relay가 queue event를 읽고 현장 DHCP/PXE·Image 작업을 실행합니다.',
                        'Compute가 JSON, form 또는 data envelope로 진행·완료 상태를 callback합니다.',
                        'Central이 hardware identity와 Compute→Relay 관계를 보강하고 Deploy·Node 상태를 갱신합니다.',
                    ],
                },
                {
                    title: '복구 분기',
                    bullets: [
                        '읽을 수 없거나 event_id가 없는 sync event는 .bad로 격리하고 relay_sync_corrupt 신호를 남긴 뒤 나머지 batch를 계속 처리합니다.',
                        '정상 event는 ACK·retry 상태를 확인하고 중복·지연 callback은 stale 보호가 현재 active Image나 Disk-Ful deploy를 덮어쓰지 않는지 확인합니다.',
                        'Disk-Ful 완료는 verify-pending과 Local Boot 후처리, Disk-Less 완료는 active Image와 deployed 상태를 별도로 확인합니다.',
                    ],
                },
                {
                    title: '실패 확인 순서',
                    steps: [
                        '중앙→Relay 통신과 queue 파일 상태를 확인합니다.',
                        'Relay 자산 동기화, DHCP/PXE와 Compute 접근성을 확인합니다.',
                        'callback의 Node·event ID, action과 발생 시각을 확인합니다.',
                        'Jobs, Relay signal과 Node deploy JSONL을 함께 대조합니다.',
                    ],
                },
            ],
        },
        {
            id: 'advanced-public-api',
            category: 'admin',
            title: '고급 공개 API와 연동 계약',
            summary: 'API 인증·scope·trace와 Version Profile, Integration·Webhook 계약 범위를 설명합니다.',
            icon: 'bx bx-code-curly',
            audience: '관리자 · 개발자',
            path: '/kiera/swagger',
            tags: ['Public API', 'JWT', 'API Key', 'Scope', 'Webhook', 'Version Profile', 'TTA'],
            sections: [
                {
                    title: '인증과 추적',
                    bullets: [
                        'Public API는 JWT token·refresh 또는 API Key를 사용하고 role과 scope를 함께 검사합니다.',
                        'Swagger session은 현재 역할에 맞는 scope를 가진 단기 token을 발급합니다.',
                        '일반 요청의 X-Request-ID와 Public API의 X-Trace-Id 및 trace_id는 통일됩니다. X-Request-ID를 우선하고 legacy X-Trace-Id도 호환 입력으로 받습니다.',
                    ],
                },
                {
                    title: '운영 API',
                    bullets: [
                        'Node 조회·등록·제어·배포, Image, Script action, Inspect와 integration summary를 제공합니다.',
                        'Version Profile은 category와 target으로 조회하고 name·version·channel·notes를 upsert합니다.',
                        'Ops Asset은 Group/Rack, Cluster Head, Node와 Image 준비 상태을 묶어 조회합니다.',
                        'TTA performance profile과 RFP traceability는 별도 운영 계약으로 확인합니다.',
                    ],
                },
                {
                    title: 'Webhook 전송과 검증 범위',
                    warning: '최고관리자는 API 문서 화면에서 Webhook 수신 URL·이벤트·비밀키를 등록하고 테스트할 수 있습니다. 변경 이벤트는 DB에 보관한 뒤 HMAC 서명과 함께 전송하며 일시 오류는 최대 5회 재시도합니다.',
                    note: '현재 OpenAPI는 39개 operation의 상세 명세를 제공합니다. 모든 장비·역할·경계 입력의 E2E를 수행했다는 뜻은 아니므로 자동화 대상별 검증을 병행합니다.',
                },
            ],
        },
        {
    "id": "data-security-boundaries",
    "category": "admin",
    "title": "데이터·파일·비밀정보·감사 기록",
    "summary": "업무 DB, 계정·RAG 저장소, Redis와 공유 파일의 소유권과 보안 경계를 설명합니다.",
    "icon": "bx bx-data",
    "audience": "관리자 · 개발자",
    "path": "/kiera/management-settings",
    "tags": [
        "PostgreSQL",
        "SQLite",
        "Redis",
        "File Store",
        "Secret",
        "Audit"
    ],
    "sections": [
        {
            "title": "저장소 구분",
            "bullets": [
                "Node, Deploy, Operation, Relay와 BMC 업무 데이터는 PostgreSQL에 저장합니다.",
                "계정·조직·API 자격정보는 base.db, Assistant RAG는 별도 SQLite에 저장합니다.",
                "Redis DB1은 Spring 공유 session에 사용합니다. 현재 Java operation worker는 Redis AsyncResult나 DB0 result backend를 사용하지 않으며 작업 결과는 PostgreSQL operation_task가 기준입니다.",
                "Image, PE, PXE, Script, SSH Key, log와 snapshot은 공유 data 파일 영역을 사용합니다."
            ]
        },
        {
            "title": "비밀정보와 감사 기록",
            "bullets": [
                "BMC와 Key Pair 등 일부 credential은 암호화하며 지원되는 API 응답·감사 경로에서 민감값을 가립니다. 모든 저장값·서비스 로그·Reveal 응답이 자동으로 보호되는 것은 아닙니다.",
                "Activity Audit은 중첩 password/token/email/mobile 값을 가리고 상세 길이를 제한합니다.",
                "파일에 덧붙이는 감사 기록은 프로세스 간 잠금과 안정적인 기록 전달·저장 장치가 없어 일부 기록이 누락될 수 있습니다. 보안 감사의 유일한 근거로 사용하지 않습니다."
            ]
        },
        {
            "title": "현재 무결성 주의",
            "warning": "업무 DB table에는 foreign key가 없어 삭제·이력 보존 관계를 application 로직이 관리합니다. DB row를 직접 수정하거나 삭제하지 마세요.",
            "bullets": [
                "Lustre MGS 암호와 Cluster DB 개인키는 암호화합니다. 기존 Lustre 평문 설정은 읽을 때 이전하며 조회 응답은 암호를 가립니다. SSH용 개인키 파일과 복구 키는 접근 권한으로 보호합니다.",
                "백업·복구 시 DB와 공유 파일을 같은 시점으로 다루고 Field Encryption key도 안전하게 보존합니다. 암호화된 DB만 복구하면 credential을 해독하지 못할 수 있습니다."
            ]
        },
        {
            "title": "중앙 상태 백업과 복구",
            "bullets": [
                "Java 수동 백업 도구는 KiERA·Zabbix PostgreSQL, Redis, SQLite, 공유 파일, 설정·키, UI/JAR과 필요한 이미지를 manifest·checksum과 함께 로컬 보관합니다.",
                "자동 주기 백업은 사용하지 않습니다. 운영자가 필요할 때 수동 실행하며 기본으로 최신 완료 백업 1개만 보존합니다. 실행 성공, 저장 용량과 manifest 검사를 별도로 확인합니다.",
                "복원은 checksum, DB row, Redis·SQLite, 공유 파일, 인증 조회와 대표 CRUD를 격리 환경에서 확인한 뒤 운영 전환합니다.",
                "로컬 백업은 호스트·디스크 손실 복구가 아니며 원격 복제, RPO/RTO, WAL/PITR와 저장소 간 동일 시점 보장은 별도 운영 설계가 필요합니다."
            ]
        },
        {
            "title": "수동 백업 실행 절차와 확인 사항",
            "steps": [
                "중앙 서버의 프로젝트 루트에서 infra/kiera-backup/README.md와 실행 컨테이너를 확인합니다. root 또는 Docker 소켓 권한·충분한 디스크 공간이 필요합니다.",
                "현재 Java 백업 도구는 RabbitMQ 없이 DB 큐를 백업합니다. PostgreSQL dump에 operation_task·agent_task를 보존하며 manifest의 queue_backend=postgresql을 확인합니다.",
                "지원 조건을 충족한 환경에서 수동 실행한 뒤 completed=true·종료 코드와 생성된 state-*의 manifest.json·체크섬을 확인합니다. 실패 백업을 정상 복원본으로 사용하지 않습니다.",
                "기본 저장 위치는 infra/kiera-docker/backups/runtime-state/이며 최신 완료본 1개를 보존합니다. 같은 호스트의 백업이므로 외부 보관과 키 접근 통제는 별도로 준비합니다."
            ],
            "code": "docker build -f infra/kiera-backup/Dockerfile -t kiera-backup-runtime .\ndocker run --rm --network none \\\n  -e KIERA_BACKUP_PROJECT=/opt/app/project/main \\\n  -e KIERA_BACKUP_OUTPUT=/backups \\\n  -v \"$PWD:/opt/app/project/main:ro\" \\\n  -v \"$PWD/infra/kiera-docker/backups/runtime-state:/backups:rw\" \\\n  -v /var/run/docker.sock:/var/run/docker.sock \\\n  -v /var/lib/docker/volumes:/var/lib/docker/volumes:ro \\\n  kiera-backup-runtime backup --keep 1",
            "warning": "이 명령은 실제 대용량 백업을 만들고 보존 개수를 넘는 이전 완료본을 정리합니다. 이번 도움말 검수에서 백업·복원을 실행한 것은 아닙니다."
        },
        {
            "title": "격리 복구 확인",
            "paragraphs": [
                "verify-spring-restore는 Java로 격리 복원 검사를 실행합니다. Docker와 완료 백업을 준비해 DB 행·SQLite 무결성·인증 조회·대표 CRUD·DB/Redis/Spring 재기동을 검사합니다. 전체 장비 복구나 모든 장애의 자동 복구를 보장하지 않습니다."
            ],
            "code": "tools/migration/verify-spring-restore \\\n  --backup infra/kiera-docker/backups/runtime-state/state-YYYYMMDD-HHMMSS \\\n  --output /tmp/kiera-restore-verification.json",
            "note": "날짜 폴더를 실제 완료본으로 바꿉니다. 운영 서버 전체 자동 복구나 모든 장비의 무중단 복원을 보장하지 않습니다."
        }
    ]
},
        {
            id: 'known-limitations',
            category: 'admin',
            title: '현재 지원 범위와 알려진 제한',
            summary: '화면 표시, 저장값, 현재 Spring·Java 실행과 실장비 검증 범위를 구분해 안내합니다.',
            icon: 'bx bx-error-alt',
            audience: '전체 사용자 · 운영자 · 개발자',
            path: '/kiera/help',
            tags: ['제한', '미구현', '지원 범위', 'GAP', '주의'],
            sections: [
                {
                    title: '표현 기준',
                    bullets: [
                        '화면에 필드·버튼이 있어도 현재 Spring 실행 경로가 값을 적용하는지 확인합니다.',
                        '저장 성공, 작업 접수, 외부 장비 완료와 최종 상태 검증을 서로 다른 단계로 구분합니다.',
                        '과거 devlog·DB 기록만 남은 기능은 현재 Spring·Java 또는 POSIX Agent 실행 경로에 연결되지 않으면 지원 기능으로 표시하지 않습니다.',
                        '실장비·역할별 E2E를 수행하지 않은 조합은 코드 확인과 현장 검증을 구분합니다.',
                    ],
                },
                {
                    title: '사용자 영향이 큰 제한',
                    bullets: [
                        'BMC Discovery 선택 등록과 SSH Key Upload는 실제 처리·검증 경로가 연결되어 있습니다. 대상별 결과와 권한을 확인합니다.',
                        "Cluster·Relay·Subnet·Disk-Less 옵션과 Debug 7개 설정은 현재 실행 경로에 연결됩니다. Debug는 서버의 지원 응답을 확인하고, Agent 유지관리는 선택 노드·기본 비활성 조건과 전체 이관 미완료를 구분하세요.",
                        'Job cancel은 남은 Node 실행과 대기 Agent 작업을 막지만 이미 시작된 외부 작업을 되돌리지는 않습니다. OpenAPI 39개 operation의 명세와 실제 장비 결과를 구분합니다.',
                        'Webhook은 최소 1회 전송 방식이므로 수신 측에서 이벤트 ID로 중복을 제거해야 합니다. 원격 작업 취소는 이미 발생한 장비 변경을 되돌리지 않습니다.',
                        'Spring 이중 인스턴스와 로컬 백업은 호스트 장애·원격 재해복구를 보장하지 않습니다. 이전 RabbitMQ 실패 보관 데이터는 전환 시 보존하며 자동 재실행하지 않습니다.',
                    ],
                },
                {
                    title: '사용 전 확인',
                    steps: [
                        '관련 가이드의 현재 제한과 필요한 권한을 확인합니다.',
                        '대표 Node 또는 테스트 Cluster에서 실제 결과를 확인합니다.',
                        'Jobs, Logs와 대상 시스템의 상태를 교차 확인합니다.',
                        '제한에 해당하면 안내된 대체 경로를 사용하고 정상 기능처럼 우회 구현하지 않습니다.',
                    ],
                    note: '전체 제한의 근거와 세부 항목은 WIZ KiERA 전체 기능 체크리스트의 GAP-001~054에서 관리합니다.',
                },
            ],
        },
        {
            id: 'help-maintenance',
            category: 'admin',
            title: '도움말 작성과 유지관리',
            summary: '현재 제품 동작을 기준으로 사용자가 따라 할 수 있는 도움말을 작성합니다.',
            icon: 'bx bx-edit',
            audience: '개발자 · 문서 담당자',
            path: '/kiera/help',
            tags: ['도움말', '문서', '유지관리', '작성 규칙'],
            sections: [
                {
                    title: '작성 원칙',
                    bullets: [
                        '기존 문서는 분류, 흐름과 표현 방식을 참고하고 현재 제품 내용을 새로 작성합니다.',
                        '화면 이름, URL, 버튼과 상태값은 실제 WIZ KiERA 동작과 일치시킵니다.',
                        '사용자의 목적, 전제조건, 단계, 확인 방법과 주의사항 순서로 설명합니다.',
                        '내부 구현 설명보다 화면에서 해야 할 행동과 결과를 우선합니다.',
                    ],
                },
                {
                    title: '추가·수정 절차',
                    steps: [
                        '관련 화면 소스와 현재 동작을 확인합니다.',
                        '기존 분류에 문서를 추가하고 검색 태그와 목록·상세·보조 화면 경로를 guideRelatedPaths에 지정합니다.',
                        '등록된 KiERA route가 적어도 한 문서의 관련 화면에 연결되는지 확인하고 동적 :id 경로는 템플릿으로만 표시합니다.',
                        '데스크톱과 모바일에서 목록, 검색, 이동과 코드 복사를 확인합니다.',
                        '문서의 #guide-id 주소를 새로 열어 선택 상태가 복원되는지 확인합니다.',
                        'WIZ 빌드 후 실제 로그인 권한에서 문서를 검토합니다.',
                    ],
                },
                {
                    title: '금지 사항',
                    bullets: [
                        '과거 매뉴얼 내용을 현재 기능처럼 그대로 복사하지 않습니다.',
                        '실제 비밀번호, 토큰, 개인키와 내부 전용 주소를 예시에 넣지 않습니다.',
                        '실행하지 않은 명령과 확인하지 않은 동작을 성공 사례로 적지 않습니다.',
                    ],
                },
            ],
        },
        {
            "id": "ssh-access-inventory",
            "category": "operations",
            "title": "SSH 공개키와 사용처 조회",
            "summary": "등록·클러스터·서버·수집 공개키를 모아 노드와 그룹 사용처를 확인합니다.",
            "icon": "bx bx-key",
            "audience": "운영자 · 계정 관리자",
            "path": "/kiera/ssh-access",
            "tags": [
                "SSH",
                "authorized_keys",
                "공개키",
                "사용처"
            ],
            "sections": [
                {
                    "title": "조회 순서",
                    "steps": [
                        "운영 / 점검의 SSH Access Management에서 키 유형·클러스터·검색어로 목록을 좁힙니다. 같은 공개키 재료는 하나로 합쳐 표시합니다.",
                        "키를 선택해 읽기 전용 공개키, 지문, 등록 위치와 연결된 노드·그룹을 확인합니다.",
                        "설정상 연결과 노드의 authorized_keys에서 관찰된 사용을 구분합니다. 수집 시각을 보고 필요하면 해당 노드를 다시 수집합니다."
                    ]
                },
                {
                    "title": "현재 범위와 제한",
                    "bullets": [
                        "이 화면은 공개키 인벤토리입니다. 개인키 가져오기·생성은 SSH Key Management에서 수행하며, CA·인증서 발급 화면은 현재 제공하지 않습니다.",
                        "노드 수집은 표준 홈의 authorized_keys 첫 64줄과 최근 인증 로그 100줄 범위입니다. 모든 SSH 인증 경로를 수집하지는 않습니다.",
                        "저장된 사용처는 현재 SSH 접속 성공을 보장하지 않습니다. 키별 감사·접속 로그를 바로 조회하는 화면 연결은 미완성입니다."
                    ]
                }
            ]
        },
        {
            "id": "cluster-user-management",
            "category": "operations",
            "title": "클러스터 OS 사용자·그룹·세션",
            "summary": "KiERA 로그인 계정과 별도로 대상 노드의 일반 OS 계정을 관리합니다.",
            "icon": "bx bx-user-circle",
            "audience": "운영자 · 계정 관리자",
            "path": "/kiera/cluster-users",
            "tags": [
                "Users",
                "Groups",
                "Sessions",
                "Audit",
                "클러스터 사용자"
            ],
            "sections": [
                {
                    "title": "조회와 수집",
                    "steps": [
                        "Cluster User Management에서 클러스터와 대상 노드를 선택합니다. 필요한 관리 계정·SSH 인증·sudo 조건을 확인합니다.",
                        "수집을 실행한 뒤 Users·Groups·Sessions와 수집 시각을 확인합니다. 새로고침은 저장된 snapshot을 읽으며 새 SSH 수집과 다릅니다.",
                        "권한이 허용하는 일반 계정 생성·수정·잠금·해제·삭제, 그룹 구성원 변경 또는 세션 종료를 선택하고 대상별 결과와 Audit Logs를 확인합니다."
                    ]
                },
                {
                    "title": "계정 접근과 보호 조건",
                    "bullets": [
                        "새 계정은 암호 인증이 비활성인 상태로 생성됩니다. 계정 생성만으로 접속할 수 없으며 공개키 등록·접속 확인으로 이어지는 화면 흐름은 아직 완성되지 않았습니다.",
                        "새 사용자 창의 인증서 안내는 현재 SSH 인벤토리 화면과 맞지 않습니다. 현재 화면에서 인증서를 설정할 수 있다고 해석하지 마세요.",
                        "시스템 UID/GID 계정은 변경 보호 대상이며 계정 삭제 시 홈을 보존합니다. 세션 관리는 systemd-logind 지원 노드에 한정합니다.",
                        "대표 VM의 실제 계정·키·잠금·세션 동작 기록은 있으나 모든 OS·복수 실제 클러스터·화면 변경 흐름과 CSV 내용까지 검증한 것은 아닙니다."
                    ]
                }
            ]
        },
        {
    "id": "kiera-cli",
    "category": "admin",
    "title": "kiera CLI 사용법",
    "summary": "서버 연결과 로그인, 조회 명령, 작업 결과 확인 및 종료 코드 사용법입니다.",
    "icon": "bx bx-terminal",
    "audience": "운영자 · 자동화 개발자",
    "tags": [
        "CLI",
        "kiera",
        "terminal",
        "command",
        "명령어"
    ],
    "sections": [
        {
            "title": "설치 위치와 실행 조건",
            "paragraphs": [
                "CLI는 Java 25의 kiera-tools.jar로 실행합니다. 서버 설치 시 kiera 명령을 제공합니다. 별도 PC에서도 같은 릴리스의 실행 JAR과 Java 25를 준비하거나 소스의 scripts/kiera를 실행합니다."
            ],
            "code": "java --version\ncommand -v kiera\nscripts/kiera --help\n# 별도 PC: 같은 릴리스의 Java 25 실행 JAR 사용\njava -jar infra/kiera-tools/target/kiera-tools.jar cli --help",
            "note": "이 예제는 소스 checkout 루트에서 실행합니다. command not found이면 설치 위치와 PATH를 확인합니다. 명령 파일만 복사해도 서버나 노드가 자동 설치되지는 않습니다."
        },
        {
            "title": "접속 준비",
            "paragraphs": [
                "설치된 kiera --help로 명령을 확인합니다. 서버 주소는 KiERA API에 연결되는 URL을 사용하고 전역 --server·--output 옵션은 하위 명령 앞에 둡니다. 원격 접속에는 실제 HTTPS 주소를 사용합니다.",
                "로그인은 대화형 프롬프트에 계정과 비밀번호를 입력합니다. 설정·인증정보는 ~/.config/kiera/config.json에 0600 권한으로 저장됩니다. 다른 사용자와 공유하지 마세요."
            ],
            "code": "kiera --help\nkiera --server https://kiera.example.com auth login\nkiera --output json node list\nkiera node status --nodes 123\nkiera image list\nkiera cluster list"
        },
        {
            "title": "작업 실행 전 확인",
            "bullets": [
                "예제 URL과 노드 ID 123은 실제 환경값으로 바꿉니다. --nodes·--groups·--racks로 대상을 지정하고 제외 옵션을 확인합니다.",
                "등록은 node register --help, 배포는 action deploy --help, 전원 조회는 node control --help에서 필수 옵션을 확인합니다. 등록의 --no-agent-install은 SSH 스캔 후 Agent 자동 설치를 생략합니다.",
                "작업 접수 응답과 실제 장비 완료는 다릅니다. 반환된 작업 ID를 보존하고 Jobs·노드 상태·로그에서 최종 결과를 확인합니다. 호환 --sync·--run-now 옵션만으로 DB 큐를 우회한다고 가정하지 마세요."
            ],
            "code": "kiera node register --help\nkiera action deploy --help\nkiera node control --help\nkiera auth api-key create --help"
        },
        {
            "title": "출력·인증·오류",
            "bullets": [
                "자동화에는 --output json을 사용합니다. 로그인 프롬프트는 stderr로 분리되며 stdout의 JSON에는 인증 비밀값을 가립니다.",
                "API Key는 auth api-key create/list/revoke로 관리합니다. 만료된 access token은 저장 refresh token으로 한 번 갱신·재시도하며 갱신 실패 시 다시 로그인합니다.",
                "종료 코드: 0 성공, 1 일반 오류, 2 사용법·입력, 3 인증·권한, 4 대상 없음, 5 충돌, 6 서버 오류, 7 연결 오류. JSON 응답과 종료 코드를 함께 확인합니다."
            ]
        },
        {
            "title": "서버 선택·로그아웃·자동 완성",
            "bullets": [
                "--server는 이번 요청의 서버를 선택합니다. 다른 서버에서는 그 서버에 로그인하세요. auth add --url은 저장된 로그인 상태에서 서버 주소를 등록하지만 다른 서버의 인증 성공을 검증하는 명령은 아닙니다.",
                "auth logout은 이 PC에 저장된 token·refresh token·API Key를 지웁니다. 이미 발급한 API Key의 서버 폐기는 auth api-key revoke로 별도 처리합니다.",
                "Bash 자동 완성은 현재 셸에 적용합니다. HTTPS 인증서 오류는 올바른 서버 주소와 신뢰 체인을 확인하고 운영 접속의 인증 검증을 임의로 끄지 않습니다."
            ],
            "code": "kiera --server https://kiera.example.com node list\nkiera auth add --url https://kiera.example.com\nkiera completion --shell bash > /tmp/kiera-completion.bash\nsource /tmp/kiera-completion.bash\nkiera auth logout"
        },
        {
            "title": "등록·배포 실사용 예제",
            "code": "kiera node register --name example-node --ip 192.0.2.10 --ssh-user root --ssh-port 22 --no-agent-install\nkiera --output json node status --nodes 123\nkiera action deploy 123 --image-id 45\nkiera --output json node status --nodes 123",
            "warning": "주소 192.0.2.10·노드 123·이미지 45는 예시입니다. 실제 값으로 바꾼 뒤 실행하세요. 등록은 원격 SSH 수집과 저장을 수행하며 배포는 디스크와 OS를 변경합니다. --no-agent-install은 Agent 자동 설치만 생략합니다. SSH 비밀번호는 프롬프트에 입력합니다.",
            "note": "반환된 operation ID를 보존하고 Jobs·Agent 결과·노드의 최종 상태를 확인합니다. 등록·작업 접수의 종료 코드 0을 장비 배포 완료로 해석하지 않습니다."
        }
    ]
},
        {
            "id": "architecture-views",
            "category": "start",
            "title": "관점별 아키텍처 읽기",
            "summary": "전체 구성·설치 위치·네트워크·데이터·작업 실행·모니터링을 여섯 관점으로 살펴봅니다.",
            "icon": "bx bx-sitemap",
            "audience": "운영자 · 개발자",
            "tags": [
                "Architecture",
                "DB",
                "Network",
                "아키텍처"
            ],
            "sections": [
                {
                    "title": "그림 선택",
                    "bullets": [
                        "전체 그림은 사용자·중앙 서버·Relay·Compute의 연결을, 배포 그림은 각 구성요소의 설치 위치를 보여줍니다. 같은 호스트의 Spring JVM 두 개는 호스트 이중화가 아닙니다.",
                        "네트워크 그림의 포트는 기본 설정입니다. 실제 서버 주소·포트 변경과 방화벽 정책은 해당 환경의 설정을 확인합니다.",
                        "데이터 그림은 논리적 저장 책임을 보여주며 전체 컬럼·외래키를 담은 물리 ERD가 아닙니다. 계정 저장소와 파일 감사 로그는 통합 도움말의 저장소 설명을 함께 봅니다.",
                        "작업 실행은 Java Worker의 DB 확인·Spring 호출과 Spring의 선점·실행·결과 기록을 구분합니다. 모니터링은 Zabbix 전용 DB와 KiERA 업무 DB를 구분합니다."
                    ]
                },
                {
                    "title": "실행 환경 확인",
                    "note": "그림은 현행 소스 구조를 설명합니다. 2026-10-29 기록에서 Rome은 DB 큐 전환을 확인했고 시즌 Worker·RabbitMQ는 미전환 상태였습니다. 그림만으로 서버별 전환 완료를 판단하지 않습니다."
                }
            ]
        },
    ];

    /** 한 문서가 연결하는 목록·상세·보조 화면을 현재 등록 route와 대조합니다. */
    public guideRelatedPaths: { [guideId: string]: string[] } = {
    "overview": [
        "/kiera"
    ],
    "initial-setup": [
        "/kiera/management-settings",
        "/members"
    ],
    "navigation-permissions": [
        "/kiera",
        "/members"
    ],
    "rack-zone": [
        "/kiera/zones",
        "/kiera/resourcerack",
        "/kiera/provisioning-rack",
        "/kiera/operations-rack"
    ],
    "bmc-credentials": [
        "/kiera/bmc-credentials"
    ],
    "node-registration": [
        "/kiera/bmc-discovery",
        "/kiera/nodes",
        "/kiera/nodes/api-register"
    ],
    "node-management": [
        "/kiera/nodes",
        "/kiera/nodes/:id/:tab?",
        "/kiera/terminal/:nodeId",
        "/kiera/sol/:nodeId"
    ],
    "resource-grouping": [
        "/kiera/groups",
        "/kiera/groups/:id",
        "/kiera/chassis",
        "/kiera/chassis/:id/:tab?",
        "/kiera/clusters",
        "/kiera/clusters/:id/:tab?"
    ],
    "provisioning-flow": [
        "/kiera/actions",
        "/kiera/cluster-deploy",
        "/kiera/cluster-deploy/:id/:tab?",
        "/kiera/provisioning-rack"
    ],
    "subnet-pxe": [
        "/kiera/subnets"
    ],
    "image-management": [
        "/kiera/images"
    ],
    "pe-diskless": [
        "/kiera/pe",
        "/kiera/diskless"
    ],
    "script-actions": [
        "/kiera/scripts",
        "/kiera/actions"
    ],
    "cluster-deployment": [
        "/kiera/cluster-deploy",
        "/kiera/cluster-deploy/:id/:tab?"
    ],
    "relay-deployment": [
        "/kiera/cluster-deploy",
        "/kiera/cluster-deploy/:id/:tab?",
        "/kiera/relay",
        "/kiera/relay/:id"
    ],
    "deployment-checklist": [
        "/kiera/cluster-deploy",
        "/kiera/jobs",
        "/kiera/logs"
    ],
    "dashboard-rack": [
        "/kiera",
        "/kiera/resourcerack",
        "/kiera/provisioning-rack",
        "/kiera/operations-rack",
        "/kiera/status"
    ],
    "job-management": [
        "/kiera/jobs"
    ],
    "service-logs": [
        "/kiera/logs",
        "/kiera/log-policy",
        "/kiera/debug"
    ],
    "inspect": [
        "/kiera/inspect"
    ],
    "terminal-sol": [
        "/kiera/nodes/:id/:tab?",
        "/kiera/terminal/:nodeId",
        "/kiera/sol/:nodeId"
    ],
    "monitoring-integrations": [
        "/kiera/zabbix",
        "/kiera/lustre",
        "/kiera/juju"
    ],
    "discovery-troubleshooting": [
        "/kiera/bmc-discovery",
        "/kiera/bmc-credentials"
    ],
    "pxe-deployment-troubleshooting": [
        "/kiera/inspect",
        "/kiera/subnets",
        "/kiera/pe",
        "/kiera/logs"
    ],
    "management-settings": [
        "/kiera/management-settings",
        "/kiera/debug",
        "/kiera/log-policy"
    ],
    "users-permissions": [
        "/members"
    ],
    "public-api": [
        "/kiera/swagger",
        "/kiera/nodes/api-register"
    ],
    "development-build-test": [
        "/kiera/help"
    ],
    "actions-backup-release": [
        "/kiera/actions",
        "/kiera/jobs"
    ],
    "ssh-key-management": [
        "/kiera/keys"
    ],
    "commissioning-agent": [
        "/kiera/actions",
        "/kiera/jobs",
        "/kiera/nodes/:id/:tab?"
    ],
    "node-status-lifecycle": [
        "/kiera/status",
        "/kiera/nodes",
        "/kiera/nodes/:id/:tab?"
    ],
    "runtime-health": [
        "/kiera/inspect",
        "/kiera/jobs",
        "/kiera/logs"
    ],
    "assistant-rag-tools": [
        "/kiera/assistant"
    ],
    "automation-schedulers": [
        "/kiera/jobs",
        "/kiera/log-policy"
    ],
    "relay-sync-recovery": [
        "/kiera/relay",
        "/kiera/relay/:id",
        "/kiera/logs"
    ],
    "advanced-public-api": [
        "/kiera/swagger"
    ],
    "data-security-boundaries": [
        "/kiera/management-settings",
        "/kiera/logs"
    ],
    "known-limitations": [
        "/kiera/help"
    ],
    "help-maintenance": [
        "/kiera/help"
    ],
    "account-session": [
        "/access",
        "/mypage"
    ],
    "ssh-access-inventory": [
        "/kiera/ssh-access/:key?"
    ],
    "cluster-user-management": [
        "/kiera/cluster-users"
    ]
};

    /** 각 도움말의 핵심 관계·순서·판단 기준을 보여 주는 이미지 모델로 제작한 PNG입니다. */
    public guideVisuals: { [guideId: string]: HelpVisual } = {
    "overview": {
        "asset": "/assets/help/visuals/architecture-20261030/00-system.png",
        "alt": "KiERA 전체 아키텍처",
        "caption": "사용자·중앙 서버·Relay·Compute의 전체 구성과 작업·배포·모니터링 연결을 보여줍니다."
    },
    "initial-setup": {
        "asset": "/assets/help/visuals/model-20261030/onboarding-flow.png",
        "alt": "권한 확인부터 단일 노드 검증까지의 초기 구성 순서도",
        "caption": "초기 운영 준비는 권한, 자격증명, 네트워크, 배포 자산, 단일 노드 검증 순서로 진행합니다."
    },
    "navigation-permissions": {
        "asset": "/assets/help/visuals/model-20261030/access-control.png",
        "alt": "메뉴 노출, 버튼 상태와 서버 권한 검사를 구분한 권한 계층도",
        "caption": "메뉴·버튼은 사용자 안내 계층이며 최종 보안 경계는 서버의 세션·권한 검사입니다. 언어 전환은 UI 문구에 적용되고 장비·로그 데이터는 원문을 유지합니다."
    },
    "rack-zone": {
        "asset": "/assets/help/visuals/model-20261030/resource-relations.png",
        "alt": "Zone, Rack, Chassis, Node, Group과 Cluster의 물리·논리 관계도",
        "caption": "Zone·Rack·Chassis는 물리 위치이고 Group·Cluster는 Node를 바라보는 논리 관계입니다."
    },
    "bmc-credentials": {
        "asset": "/assets/help/visuals/model-20261030/bmc-control-path.png",
        "alt": "Credential Profile에서 IPMI와 Redfish를 거쳐 BMC 장비를 제어하는 흐름",
        "caption": "Credential Profile은 Discovery, 전원·부팅 제어와 SOL이 공유하는 BMC 접속 경계입니다."
    },
    "node-registration": {
        "asset": "/assets/help/visuals/model-20261030/node-registration-flow.png",
        "alt": "Discovery 확인, Add·CSV·관리자 API 등록과 BMC·heartbeat 검증 흐름",
        "caption": "탐색과 등록을 분리하고 현재 지원되는 등록 진입점과 등록 후 확인 항목을 보여 줍니다."
    },
    "node-management": {
        "asset": "/assets/help/visuals/model-20261029/node-detail-evidence.png",
        "alt": "Node Summary와 Network·Storage, Devices, Zabbix, History·Timeline의 용도 관계",
        "caption": "설정 변경, 수집 데이터, 모니터링과 작업 이력을 구분해 노드 상세의 각 탭을 선택합니다."
    },
    "resource-grouping": {
        "asset": "/assets/help/visuals/model-20261030/resource-relations.png",
        "alt": "물리 계층과 Group, Cluster, Relay 역할을 구분한 자원 관계도",
        "caption": "같은 Node가 물리 배치와 여러 논리 목적에 동시에 연결될 수 있음을 보여 줍니다."
    },
    "provisioning-flow": {
        "asset": "/assets/help/visuals/model-20261030/provisioning-pipeline.png",
        "alt": "PXE부터 PE, 배포, phone-home과 heartbeat까지의 프로비저닝 단계",
        "caption": "PXE 진입부터 OS 검증까지 단계별 신호와 확인 화면을 연결한 흐름입니다."
    },
    "subnet-pxe": {
        "asset": "/assets/help/visuals/model-20261030/provisioning-pipeline.png",
        "alt": "DHCP, next-server, bootloader, PE와 이미지 전달의 PXE 흐름",
        "caption": "Subnet 설정은 DHCP 응답, 부트로더와 PE 자산 전달 경로를 결정합니다."
    },
    "image-management": {
        "asset": "/assets/help/visuals/model-20261030/image-readiness-flow.png",
        "alt": "이미지 유형 선택, 파일 업로드, 아키텍처·부팅 모드 대조와 테스트 배포 순서",
        "caption": "업로드와 배포 준비를 구분하고 이미지 유형·대상 호환성·Relay 동기화까지 확인합니다."
    },
    "pe-diskless": {
        "asset": "/assets/help/visuals/model-20261030/pe-diskless-modes.png",
        "alt": "PE 설치 전 환경, Disk-Ful 로컬 설치, Disk-Less 네트워크 부팅과 PE 보호값 비교",
        "caption": "PE와 목표 OS의 역할을 나누고 Disk-Ful·Disk-Less의 저장 경로와 런타임 보호값을 비교합니다."
    },
    "script-actions": {
        "asset": "/assets/help/visuals/model-20261030/script-execution-flow.png",
        "alt": "Script 준비 후 Scripts의 SSH 실행과 Actions의 Agent poll/report 실행이 결과 조회로 합류하는 흐름",
        "caption": "SSH 원격 실행과 Agent 작업 실행의 다른 전제조건을 보여 주고 Jobs·Logs에서 결과를 대조합니다."
    },
    "cluster-deployment": {
        "asset": "/assets/help/visuals/model-20261030/deployment-modes.png",
        "alt": "Central 직접 배포와 Relay 기반 배포를 비교한 토폴로지",
        "caption": "직접 배포는 Central이 Node를 제어하고 Relay 배포는 원격망의 Relay가 Compute를 중계합니다."
    },
    "relay-deployment": {
        "asset": "/assets/help/visuals/model-20261030/deployment-modes.png",
        "alt": "Central KiERA, DHCP Authority, Member Relay와 Compute의 Authority별 sliding window 배포 관계도",
        "caption": "Authority별 슬롯은 PXE·BMC operation 완료/실패 뒤 보충되며 Java worker 전역 처리 한도와 별도입니다."
    },
    "deployment-checklist": {
        "asset": "/assets/help/visuals/model-20261030/deployment-readiness-checks.png",
        "alt": "배포 전 대상·자산·복구, 배포 중 Jobs·Rack·Logs, 배포 후 접속·장치·모니터링 점검",
        "caption": "배포 전·중·후의 다른 완료 기준과 실제 확인 화면을 단계별로 보여 줍니다."
    },
    "dashboard-rack": {
        "asset": "/assets/help/visuals/model-20261030/operations-loop.png",
        "alt": "Dashboard에서 Rack, Node, Jobs, Logs로 장애 범위를 좁히는 진단 순서",
        "caption": "전체 영향 범위에서 자원 위치와 개별 Node 증거로 단계적으로 좁혀 갑니다."
    },
    "job-management": {
        "asset": "/assets/help/visuals/model-20261102/observability-correlation.png",
        "alt": "HTTP 추적 ID·작업 ID·노드와 시각으로 로그 대조",
        "caption": "HTTP 요청의 Request ID·Trace ID와 별도 작업 ID를 구분해 Jobs·Timeline·서비스 로그를 대조합니다."
    },
    "service-logs": {
        "asset": "/assets/help/visuals/model-20261102/observability-correlation.png",
        "alt": "HTTP 추적 ID·작업 ID·노드와 시각으로 로그 대조",
        "caption": "HTTP 요청의 Request ID·Trace ID와 별도 작업 ID를 구분해 Jobs·Timeline·서비스 로그를 대조합니다."
    },
    "inspect": {
        "asset": "/assets/help/visuals/model-20261029/inspect-safety-levels.png",
        "alt": "Basic·Smoke·E2E Smoke의 대상과 생성 자원·장비 변경·cleanup 비교",
        "caption": "그림은 검사 대상별 변경 범위를 비교합니다. 화면의 basic/smoke 모드에서 생성 검사와 Node·Relay 실행 검사를 구분하세요."
    },
    "terminal-sol": {
        "asset": "/assets/help/visuals/model-20261030/console-channels.png",
        "alt": "브라우저에서 SSH OS 경로와 IPMI SOL BMC 경로로 나뉘는 콘솔 연결도",
        "caption": "SSH는 배포 OS, SOL은 BMC를 거쳐 BIOS·PXE·커널 이전 상태를 확인합니다."
    },
    "monitoring-integrations": {
        "asset": "/assets/help/visuals/model-20261030/integration-topology.png",
        "alt": "Central, Relay, Compute와 Zabbix, Lustre, Juju의 외부 연동 관계도",
        "caption": "모니터링·스토리지·오케스트레이션 연동은 각각 다른 접속과 상태 기준을 사용합니다."
    },
    "discovery-troubleshooting": {
        "asset": "/assets/help/visuals/model-20261030/bmc-control-path.png",
        "alt": "BMC Discovery와 전원 제어 실패를 Credential, 네트워크, 프로토콜 순으로 점검하는 흐름",
        "caption": "Credential, 관리망 도달성, IPMI/Redfish 결과를 분리해 BMC 실패 지점을 찾습니다."
    },
    "pxe-deployment-troubleshooting": {
        "asset": "/assets/help/visuals/model-20261030/provisioning-pipeline.png",
        "alt": "DHCP부터 bootloader, PE, 이미지, phone-home까지 PXE 장애 지점도",
        "caption": "마지막 성공 단계를 기준으로 DHCP, 부트 자산, PE와 상태 보고를 순서대로 확인합니다."
    },
    "management-settings": {
        "asset": "/assets/help/visuals/model-20261030/management-setting-boundary.png",
        "alt": "Debug 설정·실행·복구 확인 순서",
        "caption": "Debug는 서버 지원 응답과 실행 결과를 확인하고, 진단 후 설정을 복원합니다."
    },
    "users-permissions": {
        "asset": "/assets/help/visuals/model-20261030/access-control.png",
        "alt": "사용자 역할에서 메뉴, 버튼과 서버 API 권한으로 이어지는 계층도",
        "caption": "역할 정책과 기능별 action 권한을 UI 노출과 서버 거부 양쪽에서 검증합니다."
    },
    "public-api": {
        "asset": "/assets/help/visuals/model-20261030/api-runtime.png",
        "alt": "39개 상세 OpenAPI operation, 인증·권한, Public API 실행과 현장 검증 경계",
        "caption": "내장 명세 39개 operation의 요청·응답과 실제 인증·scope·장비 결과를 함께 확인합니다."
    },
    "development-build-test": {
        "asset": "/assets/help/visuals/model-20261030/development-verification-flow.png",
        "alt": "현재 코드 추적, 계약 검증, WIZ·Java 빌드, 불변 Spring 이미지 순차 배포와 브라우저 검증 순서",
        "caption": "WIZ 빌드와 Java 시험 뒤 완성 JAR을 이미지에 넣고 secondary→primary 순서로 교체·검증합니다."
    },
    "actions-backup-release": {
        "asset": "/assets/help/visuals/model-20261030/actions-execution-state.png",
        "alt": "Actions 확인부터 operation, BMC·PXE·Agent 실행, callback과 최종 상태까지의 흐름",
        "caption": "작업 접수, 외부 side effect, callback과 최종 검증을 분리하고 cancel의 비롤백 경계를 표시합니다."
    },
    "ssh-key-management": {
        "asset": "/assets/help/visuals/model-20261030/ssh-key-lifecycle.png",
        "alt": "SSH Key Pair 생성·가져오기, 키 열람 권한과 감사 기록, 사용처 점검과 교체·삭제",
        "caption": "개인키 가져오기는 형식·passphrase·공개키 일치를 검사합니다. 교체·삭제 전 사용처를 확인합니다."
    },
    "commissioning-agent": {
        "asset": "/assets/help/visuals/model-20261029/agent-reporting-channels.png",
        "alt": "Commissioning 정보 수집, DB agent_task의 HTTP poll/report와 phone-home·heartbeat 비교",
        "caption": "정보 수집·Agent 작업·상태 보고는 별도 채널입니다. 그림은 모든 노드가 반드시 거치는 단일 순서가 아닙니다."
    },
    "node-status-lifecycle": {
        "asset": "/assets/help/visuals/model-20261102/node-lifecycle-state.png",
        "alt": "노드 상태와 Disk-Ful·Disk-Less의 서로 다른 완료 조건",
        "caption": "ready는 수집 완료 또는 Release 뒤에도 표시됩니다. 전원·OS 접속·모니터링은 별도로 확인합니다."
    },
    "runtime-health": {
        "asset": "/assets/help/visuals/architecture-20261030/02-deployment.png",
        "alt": "KiERA 배포 아키텍처",
        "caption": "중앙·Relay·Compute의 설치 위치입니다. 같은 호스트의 JVM 두 개는 호스트 이중화가 아닙니다."
    },
    "assistant-rag-tools": {
        "asset": "/assets/help/visuals/model-20261030/assistant-safety-boundary.png",
        "alt": "Assistant 질문, RAG, 읽기 Tool과 확인이 필요한 변경 Tool의 보안 경계",
        "caption": "읽기와 변경 작업을 분리하고 allowed root, confirm과 audit 경계를 표시합니다."
    },
    "automation-schedulers": {
        "asset": "/assets/help/visuals/model-20261030/automation-scheduler-timeline.png",
        "alt": "Java operation worker 전역 동시 처리, Relay Authority별 window와 주기 유지관리의 서로 다른 제어 계층",
        "caption": "Java worker의 전체 작업 처리 한도, Authority별 Relay window와 정책별 실행 시점에 따른 유지관리는 서로 다른 제어 계층입니다."
    },
    "relay-sync-recovery": {
        "asset": "/assets/help/visuals/model-20261030/relay-sync-recovery.png",
        "alt": "Central queue, Relay 처리, Compute callback, ACK·retry와 손상 event 격리 흐름",
        "caption": "정상 동기화와 .bad 격리, stale callback 보호를 하나의 복구 흐름으로 연결합니다."
    },
    "advanced-public-api": {
        "asset": "/assets/help/visuals/model-20261030/public-api-contract-boundary.png",
        "alt": "Public API 인증, 상세 operation 39개, 실행 API와 Webhook delivery 경계",
        "caption": "OpenAPI 39개 operation과 Webhook 구독·DB 보관·서명·재시도 경로를 구분합니다."
    },
    "data-security-boundaries": {
        "asset": "/assets/help/visuals/architecture-20261030/04-data-db.png",
        "alt": "KiERA 데이터·DB 아키텍처",
        "caption": "논리적 저장 책임을 보여줍니다. 감사에는 DB 외 JSONL 파일도 사용하며, 전체 물리 ERD는 아닙니다."
    },
    "known-limitations": {
        "asset": "/assets/help/visuals/model-20261029/support-evidence-levels.png",
        "alt": "화면 존재, 저장 성공, 현재 Spring 구현과 실장비·권한별 현장 검증의 네 근거 비교",
        "caption": "기능 지원 판정에 필요한 근거를 구분하고 미구현·미적용·과거 흔적·미검증을 현재 지원과 혼동하지 않습니다."
    },
    "help-maintenance": {
        "asset": "/assets/help/visuals/model-20261030/help-maintenance.png",
        "alt": "코드 확인, 문서 작성, 검색 연결, 빌드와 검수의 도움말 유지관리 흐름",
        "caption": "도움말은 실제 코드 확인부터 검색성·반응형 화면 검증까지 하나의 변경으로 관리합니다."
    },
    "ssh-access-inventory": {
        "asset": "/assets/help/visuals/model-20261102/ssh-inventory.png",
        "alt": "공개키 목록 검색·상세·수집 근거 확인",
        "caption": "읽기 전용 인벤토리의 지문·사용처와 설정 연결·관찰 시각을 구분합니다."
    },
    "cluster-user-management": {
        "asset": "/assets/help/visuals/model-20261102/cluster-users.png",
        "alt": "클러스터 OS 계정 수집·사용자와 그룹·세션과 감사",
        "caption": "선택 노드의 OS 계정을 관리합니다. KiERA 로그인 계정과 다릅니다."
    },
    "kiera-cli": {
        "asset": "/assets/help/visuals/model-20261102/cli-workflow.png",
        "alt": "CLI 설치 확인·로그인·대상 선택·최종 결과 확인",
        "caption": "CLI 실행 조건과 대상·출력·최종 결과를 확인합니다. 작업 접수와 장비 완료는 별개입니다."
    },
    "architecture-views": {
        "asset": "/assets/help/visuals/architecture-20261030/00-system.png",
        "alt": "KiERA 전체 아키텍처",
        "caption": "사용자·중앙 서버·Relay·Compute의 전체 구성과 작업·배포·모니터링 연결을 보여줍니다."
    },
    "account-session": {
        "asset": "/assets/help/visuals/model-20261102/account-session.png",
        "alt": "로그인·내 프로필·로그아웃의 세 단계",
        "caption": "본인 계정 관리와 세션 만료 대응입니다. OS 사용자 관리는 별도 가이드를 확인합니다."
    }
};

    /** 같은 문서에서 서로 다른 판단 축을 보여 줄 때 추가로 노출하는 보조 시각화입니다. */
    public guideVisualExtras: { [guideId: string]: HelpVisual[] } = {
    "node-status-lifecycle": [
        {
            "asset": "/assets/help/visuals/model-20261029/node-status-evidence-map.png",
            "alt": "DB 상태, BMC, Agent heartbeat, guest, Zabbix와 PXE 로그를 대조하는 상태 확인 자료",
            "caption": "Node 상태는 단일 값이 아니라 여러 채널의 관측 시각과 결과를 함께 대조해 판단합니다."
        }
    ],
    "architecture-views": [
        {
            "asset": "/assets/help/visuals/architecture-20261030/02-deployment.png",
            "alt": "KiERA 배포 아키텍처",
            "caption": "중앙·Relay·Compute의 설치 위치입니다. 같은 호스트의 JVM 두 개는 호스트 이중화가 아닙니다."
        },
        {
            "asset": "/assets/help/visuals/architecture-20261030/03-network.png",
            "alt": "KiERA 네트워크 아키텍처",
            "caption": "기본 포트와 대표 경로입니다. 실제 포트 변경·방화벽은 환경별로 확인합니다."
        },
        {
            "asset": "/assets/help/visuals/architecture-20261030/04-data-db.png",
            "alt": "KiERA 데이터·DB 아키텍처",
            "caption": "논리적 저장 책임을 보여줍니다. 감사에는 DB 외 JSONL 파일도 사용하며, 전체 물리 ERD는 아닙니다."
        },
        {
            "asset": "/assets/help/visuals/architecture-20261030/05-job-execution.png",
            "alt": "KiERA 작업 실행 아키텍처",
            "caption": "Worker는 대기 작업을 확인해 Spring을 호출하며, Spring이 작업 선점·실행·결과 기록을 담당합니다."
        },
        {
            "asset": "/assets/help/visuals/architecture-20261030/06-monitoring.png",
            "alt": "KiERA 모니터링 아키텍처",
            "caption": "Agent·Proxy·Server의 수집 경로와 Web API 조회, 별도 모니터링 DB를 구분합니다."
        }
    ],
    "jobs": [
        {
            "asset": "/assets/help/visuals/architecture-20261030/05-job-execution.png",
            "alt": "KiERA 작업 실행 아키텍처",
            "caption": "Worker는 대기 작업을 확인해 Spring을 호출하며, Spring이 작업 선점·실행·결과 기록을 담당합니다."
        }
    ],
    "subnet-pxe": [
        {
            "asset": "/assets/help/visuals/architecture-20261030/03-network.png",
            "alt": "KiERA 네트워크 아키텍처",
            "caption": "기본 포트와 대표 경로입니다. 실제 포트 변경·방화벽은 환경별로 확인합니다."
        }
    ],
    "monitoring-integrations": [
        {
            "asset": "/assets/help/visuals/architecture-20261030/06-monitoring.png",
            "alt": "KiERA 모니터링 아키텍처",
            "caption": "Agent·Proxy·Server의 수집 경로와 Web API 조회, 별도 모니터링 DB를 구분합니다."
        }
    ],
    "data-security-boundaries": [
        {
            "asset": "/assets/help/visuals/model-20261102/central-backup.png",
            "alt": "중앙 백업 실행 조건·수동 백업·격리 복구 검증",
            "caption": "노드 Safe/Live Backup과 중앙 DB·파일 백업을 구분합니다. 현재 도구의 RabbitMQ 호환 조건을 먼저 확인합니다."
        }
    ]
};

    /** 사용자가 자연어 질문으로 검색해도 관련 기능 문서가 노출되도록 하는 검색 별칭입니다. */
    public guideSearchAliases: { [guideId: string]: string[] } = {
    "overview": [
        "WIZ KiERA는 무엇인가요?",
        "WIZ KiERA로 무엇을 할 수 있나요?"
    ],
    "initial-setup": [
        "최초 설치 후 무엇부터 해야 하나요?",
        "운영 준비에 필요한 항목은 무엇인가요?",
        "처음 배포하기 전에 어떤 서비스를 확인하나요?"
    ],
    "navigation-permissions": [
        "메뉴가 보이지 않습니다.",
        "권한이 없다고 나옵니다.",
        "버튼이 비활성화되어 있습니다.",
        "메뉴 숨김과 버튼 비활성화는 무엇이 다른가요?",
        "read create update remove execute는 무엇인가요?",
        "일반 사용자 운영자 관리자 superadmin 권한은 어떻게 다른가요?",
        "URL을 직접 입력하면 권한 없이 들어갈 수 있나요?",
        "한영 전환이 일부 화면에 적용되지 않습니다."
    ],
    "rack-zone": [
        "Zone과 Rack의 차이는 무엇인가요?",
        "Rack은 어떻게 등록하나요?",
        "Node의 물리 위치는 어디에서 설정하나요?",
        "자원 관리 프로비저닝 운영 Rack View는 무엇이 다른가요?"
    ],
    "bmc-credentials": [
        "Credential은 무엇인가요?",
        "BMC Credential은 어떻게 등록하나요?",
        "Credential 접속 테스트가 실패합니다.",
        "Credential 수정에서 비밀번호를 비우면 어떻게 되나요?",
        "IPMI와 Redfish는 어떻게 다른가요?"
    ],
    "node-registration": [
        "노드를 어떻게 등록하나요?",
        "BMC Discovery 결과를 바로 Node로 등록할 수 있나요?",
        "CSV로 노드를 등록하려면 어떻게 하나요?",
        "API 노드 등록은 어디에 있나요?",
        "이미 등록된 노드가 Discovery 결과에 나오지 않습니다."
    ],
    "node-management": [
        "Node는 등록됐지만 BMC 상태가 정상 아님으로 보입니다.",
        "Node에 Heartbeat가 없습니다.",
        "Node 네트워크 정보가 없습니다.",
        "Node 장치 정보가 수집되지 않았습니다.",
        "Node의 배포 이력과 Timeline은 어디에서 보나요?"
    ],
    "resource-grouping": [
        "Node와 Cluster의 차이는 무엇인가요?",
        "Group은 언제 사용하나요?",
        "Chassis는 언제 사용하나요?",
        "Group Cluster Zone Rack의 관계는 무엇인가요?",
        "Head Relay Compute 역할은 무엇인가요?",
        "Cluster에 넣으면 Group이나 Rack도 바뀌나요?"
    ],
    "provisioning-flow": [
        "Provisioning은 무엇인가요?",
        "Commissioning은 무엇을 수집하나요?",
        "Phone-home과 Heartbeat의 차이는 무엇인가요?",
        "Bootstrap은 어떤 단계인가요?"
    ],
    "subnet-pxe": [
        "Subnet에는 무엇을 입력하나요?",
        "next-server는 무엇인가요?",
        "DHCP 범위는 어떻게 정하나요?",
        "DHCP 설정은 어디에서 적용하나요?",
        "NFS와 HTTP rootfs는 어떻게 다른가요?",
        "PXE에 사용할 인터페이스는 어떻게 고르나요?"
    ],
    "image-management": [
        "Image는 어떻게 등록하나요?",
        "Image 업로드가 실패합니다.",
        "Image가 준비되지 않음으로 보입니다.",
        "Image 다운로드가 안 됩니다."
    ],
    "pe-diskless": [
        "PE와 Image의 차이는 무엇인가요?",
        "PE는 어떻게 등록하나요?",
        "Disk-Ful과 Disk-Less의 차이는 무엇인가요?",
        "Disk-Less는 무엇인가요?",
        "DiskLess Image Linux에는 어떤 파일이 필요한가요?"
    ],
    "script-actions": [
        "Script는 어떻게 등록하나요?",
        "Script 첨부파일과 환경변수는 어떻게 사용하나요?",
        "Script 실행 대상은 어떻게 선택하나요?",
        "Script가 일부 노드에서만 실패했습니다."
    ],
    "cluster-deployment": [
        "클러스터 직접 배포는 어떻게 하나요?",
        "단일 Node 테스트 배포는 어떻게 하나요?",
        "직접 배포 전에 무엇이 준비되어야 하나요?",
        "클러스터 일부 노드만 선택해 배포할 수 있나요?",
        "직접 배포가 성공했는지 어디에서 확인하나요?",
        "Cluster Deploy 버튼이 비활성화되어 있습니다."
    ],
    "relay-deployment": [
        "Relay는 언제 사용하나요?",
        "직접 배포와 Relay 배포의 차이는 무엇인가요?",
        "Central KiERA Relay Compute 구조는 무엇인가요?",
        "Authority Relay와 Member Relay의 차이는 무엇인가요?",
        "Relay 이미지 동기화가 실패합니다.",
        "Window Size와 Window Gap은 무엇인가요?",
        "Relay 배포만 실패합니다.",
        "Compute 슬롯은 언제 해제되고 다음 노드를 시작하나요?"
    ],
    "deployment-checklist": [
        "배포 전에 반드시 확인할 항목은 무엇인가요?",
        "배포의 정상 완료 기준은 무엇인가요?"
    ],
    "dashboard-rack": [
        "운영자는 장애가 나면 어느 화면부터 보나요?",
        "대시보드의 정상 상태는 무엇인가요?",
        "Rack View에서 이상 노드를 어떻게 찾나요?",
        "warning critical unavailable은 무엇을 의미하나요?"
    ],
    "job-management": [
        "배포가 pending에서 멈췄습니다.",
        "Job이 running에서 멈췄습니다.",
        "Job이 failed 상태입니다.",
        "Job이 cancelled 상태입니다.",
        "일부 노드만 배포 실패했습니다.",
        "Job을 취소하면 실제 장비에서는 어떻게 되나요?"
    ],
    "service-logs": [
        "로그는 어디에서 확인하나요?",
        "어떤 로그를 봐야 하나요?",
        "Job ID나 trace ID로 로그를 어떻게 찾나요?",
        "완료 작업이나 Timeline 기록이 보이지 않습니다."
    ],
    "inspect": [
        "Inspect는 언제 사용하나요?",
        "Basic 검사와 Smoke Test의 차이는 무엇인가요?",
        "검사 실행이 운영 장비에 영향을 주나요?"
    ],
    "terminal-sol": [
        "배포는 성공했는데 SSH가 안 됩니다.",
        "IP는 있는데 SSH가 안 됩니다.",
        "SOL 연결이 실패합니다.",
        "SSH와 SOL은 언제 각각 사용하나요?"
    ],
    "monitoring-integrations": [
        "Zabbix가 연결되지 않습니다.",
        "Zabbix Agent 연결이 실패합니다.",
        "Relay의 Zabbix Proxy는 무엇인가요?",
        "Lustre 상태는 어디에서 확인하나요?",
        "Juju 등록 상태는 어디에서 확인하나요?"
    ],
    "discovery-troubleshooting": [
        "BMC Discovery가 안 됩니다.",
        "BMC Credential 오류가 발생합니다.",
        "BMC 연결에 실패했습니다.",
        "Power Status 조회에 실패했습니다.",
        "Power On 또는 Power Off가 실패했습니다.",
        "Reset 또는 Boot Device 변경이 실패했습니다.",
        "IPMI 명령이 실패합니다.",
        "Redfish 요청이 실패합니다."
    ],
    "pxe-deployment-troubleshooting": [
        "PXE 화면이 나오지 않습니다.",
        "DHCP 주소를 받지 못합니다.",
        "next-server가 잘못되었다고 나옵니다.",
        "bootloader 다운로드가 실패합니다.",
        "kernel 또는 initrd 다운로드가 실패합니다.",
        "PE가 시작되지 않습니다.",
        "PE에서 KiERA 서버로 상태 보고가 오지 않습니다.",
        "Disk-Less 부팅 또는 Storage mount가 실패합니다."
    ],
    "management-settings": [
        "Management Settings는 어디에서 설정하나요?",
        "관리 설정 메뉴가 보이지 않습니다."
    ],
    "users-permissions": [
        "사용자를 어떻게 추가하고 역할을 바꾸나요?",
        "기능별 역할 권한 표는 어디에 있나요?"
    ],
    "public-api": [
        "Swagger는 어디에서 열 수 있나요?",
        "공개 API 인증과 권한은 어떻게 적용되나요?",
        "Swagger에서 실행 가능한 API와 상세 미확정 경로는 어떻게 구분하나요?"
    ],
    "development-build-test": [
        "Frontend 코드는 어디부터 보면 되나요?",
        "Backend API 코드는 어디부터 보면 되나요?",
        "DB Model과 Struct는 어디에 있나요?",
        "WebSocket Java Worker DB 큐 Redis는 어디에서 사용하나요?",
        "현재 서비스와 관리 도구는 어떤 구조로 실행되나요?",
        "Node Agent는 어떤 실행 환경을 사용하나요?",
        "System Agent와 Operation Worker는 어떤 Java 구성인가요?",
        "Node 배포 기능을 수정하려면 어느 코드부터 보면 되나요?",
        "Relay 배포 기능을 수정하려면 어느 코드부터 보면 되나요?",
        "빌드 테스트 배포와 로그 위치는 어디에서 확인하나요?",
        "Spring JAR 배포는 왜 런타임 이미지를 다시 만들어야 하나요?"
    ],
    "actions-backup-release": [
        "Actions에서 노드 작업은 어떻게 실행하나요?",
        "Safe Backup과 Live Backup의 차이는 무엇인가요?",
        "Release는 Node 삭제인가요?",
        "작업 취소가 실제 장비 작업도 중단하나요?"
    ],
    "ssh-key-management": [
        "SSH Key는 어떻게 생성하고 확인하나요?",
        "Upload Key Pair가 동작하지 않습니다.",
        "Cluster SSH Key는 어디에 사용되나요?"
    ],
    "commissioning-agent": [
        "Commissioning은 어떻게 완료되나요?",
        "Phone-home과 Agent report는 무엇이 다른가요?",
        "agent_task가 db-only인 이유는 무엇인가요?",
        "Agent 작업이 pending에서 멈췄습니다."
    ],
    "node-status-lifecycle": [
        "Node 상태값은 무엇을 의미하나요?",
        "Status의 Type 필터가 동작하지 않습니다.",
        "Release와 Node 삭제의 차이는 무엇인가요?",
        "삭제한 Node의 inventory는 어디에 남나요?"
    ],
    "runtime-health": [
        "Spring primary와 secondary는 어떻게 동작하나요?",
        "Redis DB 큐 Java Worker 상태는 어디서 확인하나요?",
        "Celery worker가 Java worker로 어떻게 바뀌었나요?",
        "화면은 열리지만 배포 작업이 실행되지 않습니다.",
        "System Agent는 어떤 작업을 하나요?",
        "외부 HTTPS와 내부 3000 3001 3099 포트는 어떻게 다른가요?",
        "Spring readiness와 liveness는 무엇이 다른가요?",
        "PWA",
        "오프라인",
        "offline",
        "연결 끊김"
    ],
    "assistant-rag-tools": [
        "AI Assistant는 어떻게 설정하나요?",
        "RAG 문서를 어떻게 추가하고 활성화하나요?",
        "Assistant가 파일이나 DB를 변경할 수 있나요?",
        "allowed root와 confirm은 무엇인가요?"
    ],
    "automation-schedulers": [
        "자동으로 실행되는 작업은 무엇인가요?",
        "BMC Window Size는 어떻게 동작하나요?",
        "로그 만료 정리는 언제 실행되나요?",
        "Relay 작업은 누가 다음 단계로 진행하나요?"
    ],
    "relay-sync-recovery": [
        "Relay queue의 bad 파일은 무엇인가요?",
        "Relay callback이 늦게 도착하면 어떻게 되나요?",
        "Relay 동기화 오류를 어떻게 복구하나요?"
    ],
    "advanced-public-api": [
        "Public API의 JWT와 API Key는 어떻게 다른가요?",
        "Webhook event가 실제로 전송되나요?",
        "일부 OpenAPI path에 실행 operation이 보이지 않습니다.",
        "Version Profile과 TTA API는 무엇인가요?"
    ],
    "data-security-boundaries": [
        "KiERA 데이터는 어디에 저장되나요?",
        "PostgreSQL SQLite Redis는 무엇을 저장하나요?",
        "비밀정보와 감사 기록은 어떻게 보호되나요?",
        "DB row를 직접 수정해도 되나요?",
        "중앙 KiERA 백업은 무엇을 보존하고 어떻게 복구하나요?",
        "중앙 백업",
        "backup restore",
        "manifest checksum"
    ],
    "known-limitations": [
        "현재 동작하지 않는 기능은 무엇인가요?",
        "화면에는 있지만 저장만 되는 옵션은 무엇인가요?",
        "과거 코드와 현재 기능은 어떻게 구분하나요?",
        "실장비에서 추가 검증할 항목은 무엇인가요?"
    ],
    "help-maintenance": [
        "도움말을 수정하고 검색어를 추가하려면 어떻게 하나요?"
    ],
    "account-session": [
        "로그아웃",
        "logout",
        "password change",
        "비밀번호 변경",
        "내 프로필",
        "세션 만료"
    ],
    "kiera-cli": [
        "command not found",
        "CLI 설치",
        "CLI registration",
        "Bash completion",
        "서버 선택"
    ]
};

    public selectedCategory: string = 'all';
    public selectedGuide: HelpGuide | null = null;
    public visibleGuides: HelpGuide[] = [];
    public previousGuide: HelpGuide | null = null;
    public nextGuide: HelpGuide | null = null;
    public searchText: string = '';
    public copiedBlock: string = '';
    public openTreeGroups: { [key: string]: boolean } = {};

    constructor(@Inject( Service) public service: Service) { }

    public get selectedVisuals(): HelpVisual[] {
        if (!this.selectedGuide) return [];
        const primary = this.guideVisuals[this.selectedGuide.id];
        const extras = this.guideVisualExtras[this.selectedGuide.id] || [];
        return primary ? [primary, ...extras] : extras;
    }

    public visualAsset(visual: HelpVisual): string {
        return this.service.lang.is('en')
            ? visual.asset.replace('/visuals/', '/visuals/en/')
            : visual.asset;
    }

    public get selectedRelatedPaths(): string[] {
        if (!this.selectedGuide) return [];
        const paths = this.guideRelatedPaths[this.selectedGuide.id] || [];
        return Array.from(new Set([this.selectedGuide.path, ...paths].filter((path): path is string => Boolean(path))));
    }

    public async ngOnInit() {
        await this.service.init();
        this.categories.forEach((category) => {
            this.openTreeGroups[category.id] = true;
        });
        this.visibleGuides = this.guides.slice();
        const requestedGuideId = this.guideIdFromHash();
        this.selectedGuide = this.guides.find((guide) => guide.id === requestedGuideId) || this.guides[0];
        if (this.selectedGuide) this.openTreeGroups[this.selectedGuide.category] = true;
        this.updateAdjacentGuides();
        await this.service.render();
    }

    public categoryCount(categoryId: string): number {
        return this.guides.filter((guide) => guide.category === categoryId).length;
    }

    public categoryTitle(categoryId: string): string {
        const category = this.categories.find((item) => item.id === categoryId);
        return category ? category.title : '전체';
    }

    public tabButtonClass(categoryId: string): string {
        return this.selectedCategory === categoryId ? 'help-tab is-active' : 'help-tab';
    }

    public treeParentClass(categoryId: string): string {
        return this.treeGroupOpen(categoryId) ? 'help-tree-parent is-open' : 'help-tree-parent';
    }

    public guideButtonClass(guide: HelpGuide): string {
        return this.selectedGuide && this.selectedGuide.id === guide.id ? 'help-guide-item is-active' : 'help-guide-item';
    }

    public treeCategories(): HelpCategory[] {
        const categories = this.selectedCategory === 'all'
            ? this.categories
            : this.categories.filter((category) => category.id === this.selectedCategory);
        return categories.filter((category) => this.treeGuides(category.id).length > 0);
    }

    public treeGuides(categoryId: string): HelpGuide[] {
        return this.visibleGuides.filter((guide) => guide.category === categoryId);
    }

    public treeGroupOpen(categoryId: string): boolean {
        return this.openTreeGroups[categoryId] !== false;
    }

    public async toggleTreeGroup(categoryId: string) {
        this.openTreeGroups[categoryId] = !this.treeGroupOpen(categoryId);
        await this.service.render();
    }

    public async selectCategory(categoryId: string) {
        this.selectedCategory = categoryId;
        if (categoryId !== 'all') this.openTreeGroups[categoryId] = true;
        this.applyFilters(true);
        await this.service.render();
        this.scrollArticleTop();
    }

    public async onSearch(event: any) {
        this.searchText = String(event.target.value || '').trim();
        this.applyFilters(true);
        this.visibleGuides.forEach((guide) => {
            this.openTreeGroups[guide.category] = true;
        });
        await this.service.render();
        this.scrollArticleTop();
    }

    public async clearSearch() {
        this.searchText = '';
        this.applyFilters(true);
        await this.service.render();
    }

    public async selectGuide(guide: HelpGuide | null) {
        if (!guide) return;
        this.selectedGuide = guide;
        this.openTreeGroups[guide.category] = true;
        this.copiedBlock = '';
        this.updateAdjacentGuides();
        this.updateGuideHash(guide.id);
        await this.service.render();
        this.scrollArticleTop();
    }

    public async openGuidePath(path?: string) {
        if (!path || !this.canOpenGuidePath(path)) return;
        this.service.href(path);
    }

    public canOpenGuidePath(path: string): boolean {
        return !path.includes(':');
    }

    public async copyCode(code: string, sectionIndex: number) {
        if (!this.selectedGuide) return;

        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(code);
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = code;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }
            this.copiedBlock = this.selectedGuide.id + '-' + sectionIndex;
            await this.service.render();
        } catch (error) {
            this.copiedBlock = '';
            await this.service.render();
        }
    }

    public copyButtonLabel(sectionIndex: number): string {
        if (!this.selectedGuide) return '복사';
        return this.copiedBlock === this.selectedGuide.id + '-' + sectionIndex ? '복사됨' : '복사';
    }

    private applyFilters(selectFirst: boolean) {
        const queryTokens = this.normalizeSearch(this.searchText).split(' ').filter((token) => token.length > 0);
        this.visibleGuides = this.guides.filter((guide) => {
            const categoryMatch = this.selectedCategory === 'all' || guide.category === this.selectedCategory;
            const aliases = this.guideSearchAliases[guide.id] || [];
            const localizedGuide = JSON.stringify(guide, (_key, value) => {
                return typeof value === 'string' ? this.service.lang.localize(value) : value;
            });
            const localizedAliases = aliases.map((alias) => this.service.lang.localize(alias));
            const haystack = this.normalizeSearch(JSON.stringify({ guide, aliases, localizedGuide, localizedAliases }));
            const searchMatch = queryTokens.length === 0 || queryTokens.every((token) => haystack.includes(token));
            return categoryMatch && searchMatch;
        });

        const selectedId = this.selectedGuide ? this.selectedGuide.id : '';
        const selectedVisible = this.visibleGuides.some((guide) => guide.id === selectedId);

        if (selectFirst && !selectedVisible) {
            this.selectedGuide = this.visibleGuides.length ? this.visibleGuides[0] : null;
            if (this.selectedGuide) this.updateGuideHash(this.selectedGuide.id);
        }
        this.updateAdjacentGuides();
    }

    private guideIdFromHash(): string {
        if (typeof window === 'undefined') return '';
        return decodeURIComponent(String(window.location.hash || '').replace(/^#/, '')).trim();
    }

    private updateGuideHash(guideId: string) {
        if (typeof window === 'undefined' || !window.history || !guideId) return;
        const nextUrl = window.location.pathname + window.location.search + '#' + encodeURIComponent(guideId);
        window.history.replaceState(null, '', nextUrl);
    }

    private normalizeSearch(value: string): string {
        return String(value || '')
            .normalize('NFKC')
            .toLowerCase()
            .replace(/disk\s*[-_]?\s*less/g, 'diskless')
            .replace(/disk\s*[-_]?\s*ful/g, 'diskful')
            .replace(/[\\/_-]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    private updateAdjacentGuides() {
        this.previousGuide = null;
        this.nextGuide = null;
        if (!this.selectedGuide) return;

        const selectedId = this.selectedGuide.id;
        const index = this.visibleGuides.findIndex((guide) => guide.id === selectedId);
        if (index > 0) this.previousGuide = this.visibleGuides[index - 1];
        if (index >= 0 && index < this.visibleGuides.length - 1) this.nextGuide = this.visibleGuides[index + 1];
    }

    private scrollArticleTop() {
        setTimeout(() => {
            const article = document.getElementById('helpArticle');
            if (article) article.scrollTop = 0;
        }, 0);
    }
}

export default PageKieraHelpComponent;
